import imagePath from "@/src/paths/imagePath.js";
import { imageNames } from "@/src/constants/imageConstants.js";
import sidebarImagePath from "@/src/paths/sidebarImagePath.js";
import callImagePath from "@/src/paths/callImagePath.js";
import loaderPath from "@/src/paths/loaderPath.js";
import platformPath from "@/src/paths/platformPath.js";

export const themeIconMap = {
  [imageNames.SUPER_AGI_LOGO]: {
    darkIcon: imagePath.dark.platform.superAGILogo,
    lightIcon: imagePath.light.platform.superAGILightLogo,
  },
  [imageNames.DRAGGABLE_DOTS]: {
    darkIcon: imagePath.neutral.grey.draggableDots,
    lightIcon: imagePath.neutral.grey.draggableDots,
  },
  [imageNames.RESIZE_GRIP]: {
    darkIcon: imagePath.neutral.grey.resizeGrip,
    lightIcon: imagePath.neutral.grey.resizeGrip,
  },
  [imageNames.SIGNAL_WAVE]: {
    darkIcon: imagePath.neutral.grey.signalWave,
    lightIcon: imagePath.neutral.grey.signalWave,
  },
  [imageNames.MICROPHONE]: {
    darkIcon: imagePath.neutral.action.microphone,
    lightIcon: imagePath.neutral.action.microphone,
  },
  [imageNames.VOICE_AI_MIC]: {
    darkIcon: imagePath.neutral.action.voiceAiIconDark,
    lightIcon: imagePath.neutral.action.voiceAiIcon,
  },
  [imageNames.EMPTY_STATE_SECONDARY]: {
    darkIcon: imagePath.emptyStateSecondary,
    lightIcon: imagePath.emptyStateSecondary,
  },
  [imageNames.BOTTOM_ARROW]: {
    darkIcon: imagePath.dark.arrows.bottomArrowWhite,
    lightIcon: imagePath.neutral.arrows.bottomArrowGrey,
  },
  [imageNames.BOTTOM_ARROW_GREY]: {
    darkIcon: imagePath.neutral.arrows.bottomArrowGrey,
    lightIcon: imagePath.neutral.arrows.bottomArrowGrey,
  },
  [imageNames.RESEARCH_SELECTED]: {
    darkIcon: imagePath.dark.selected.researchSelectedIcon,
    lightIcon: imagePath.light.selected.researchSelectedLightIcon,
  },
  [imageNames.RESEARCH_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.researchUnselectedIcon,
    lightIcon: imagePath.neutral.unselected.researchUnselectedIcon,
  },
  [imageNames.BUSINESS_DETAILS_SELECTED]: {
    darkIcon: imagePath.dark.selected.businessDetailsSelectedIcon,
    lightIcon: imagePath.light.selected.businessDetailsSelectedLightIcon,
  },
  [imageNames.BUSINESS_DETAILS_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.businessDetailsUnselectedIcon,
    lightIcon: imagePath.neutral.unselected.businessDetailsUnselectedIcon,
  },
  [imageNames.GENERAL_SELECTED]: {
    darkIcon: imagePath.dark.selected.generalSelectedIcon,
    lightIcon: imagePath.light.selected.generalSelectedLightIcon,
  },
  [imageNames.GENERAL_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.generalUnselectedIcon,
    lightIcon: imagePath.neutral.unselected.generalUnselectedIcon,
  },
  [imageNames.PROFILE_SELECTED]: {
    darkIcon: imagePath.dark.selected.profileSelectedIcon,
    lightIcon: imagePath.light.selected.profileSelectedLightIcon,
  },
  [imageNames.PROFILE_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.profileUnselectedIcon,
    lightIcon: imagePath.neutral.unselected.profileUnselectedIcon,
  },
  [imageNames.INTEGRATIONS_SELECTED]: {
    darkIcon: imagePath.dark.selected.integrationsSelectedIcon,
    lightIcon: imagePath.light.selected.integrationsSelectedLightIcon,
  },
  [imageNames.INTEGRATIONS_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.integrationsUnselectedIcon,
    lightIcon: imagePath.neutral.unselected.integrationsUnselectedIcon,
  },
  [imageNames.WATERFALL_SELECTED]: {
    darkIcon: imagePath.waterfallSelectedIcon,
    lightIcon: imagePath.waterfallSelectedLightIcon,
  },
  [imageNames.WATERFALL_UNSELECTED]: {
    darkIcon: imagePath.waterfallUnselectedIcon,
    lightIcon: imagePath.waterfallUnselectedIcon,
  },
  [imageNames.EMAIL_TEMPLATES_SELECTED]: {
    darkIcon: imagePath.dark.selected.emailTemplatesSelectedIcon,
    lightIcon: imagePath.light.selected.emailTemplatesSelectedLightIcon,
  },
  [imageNames.EMAIL_TEMPLATES_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.emailTemplatesUnselectedIcon,
    lightIcon: imagePath.neutral.unselected.emailTemplatesUnselectedIcon,
  },
  [imageNames.CONTENT_SELECTED]: {
    darkIcon: imagePath.contentSelectedIcon,
    lightIcon: imagePath.contentSelectedLightIcon,
  },
  [imageNames.USERS_SELECTED]: {
    darkIcon: imagePath.dark.selected.usersSelectedIcon,
    lightIcon: imagePath.light.selected.usersSelectedLightIcon,
  },
  [imageNames.USERS_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.usersUnselectedIcon,
    lightIcon: imagePath.neutral.unselected.usersUnselectedIcon,
  },
  [imageNames.TASKS_SELECTED]: {
    darkIcon: imagePath.tasksSelectedIcon,
    lightIcon: imagePath.tasksSelectedLightIcon,
  },
  [imageNames.FOLLOW_UP_TASK_DOUBLE_ARROW]: {
    darkIcon: imagePath.doubleArrowIcon,
    lightIcon: imagePath.doubleArrowIcon,
  },
  [imageNames.TASKS_UNSELECTED]: {
    darkIcon: imagePath.tasksUnselectedIcon,
    lightIcon: imagePath.tasksUnselectedLightIcon,
  },
  [imageNames.OUTPUT_SELECTED]: {
    darkIcon: imagePath.dark.selected.outputSelectedIcon,
    lightIcon: imagePath.light.selected.outputSelectedLightIcon,
  },
  [imageNames.OUTPUT_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.outputUnselectedIcon,
    lightIcon: imagePath.neutral.unselected.outputUnselectedIcon,
  },
  [imageNames.BILLING_SELECTED]: {
    darkIcon: imagePath.dark.selected.billingSelectedIcon,
    lightIcon: imagePath.light.selected.billingSelectedLightIcon,
  },
  [imageNames.BILLING_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.billingUnselectedIcon,
    lightIcon: imagePath.neutral.unselected.billingUnselectedIcon,
  },
  [imageNames.VOICEMAIL_SELECTED]: {
    darkIcon: imagePath.dark.selected.voicemailSelectedIcon,
    lightIcon: imagePath.light.selected.voicemailSelectedLightIcon,
  },
  [imageNames.VOICEMAIL_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.voicemailUnselectedIcon,
    lightIcon: imagePath.neutral.unselected.voicemailUnselectedIcon,
  },
  [imageNames.VOICEMAIL_DROP_SELECTED]: {
    darkIcon: callImagePath.voicemailDropSelectedIcon,
    lightIcon: callImagePath.voicemailDropSelectedLightIcon,
  },
  [imageNames.VOICEMAIL_DROP_UNSELECTED]: {
    darkIcon: callImagePath.voicemailDropUnselectedIcon,
    lightIcon: callImagePath.voicemailDropUnselectedLightIcon,
  },
  [imageNames.SEARCH_VARIANT1]: {
    darkIcon: imagePath.dark.action.searchVariant1,
    lightIcon: imagePath.light.action.searchVariant1,
  },
  [imageNames.SEARCH]: {
    darkIcon: imagePath.dark.action.searchIcon,
    lightIcon: imagePath.light.action.searchLightIcon,
  },
  [imageNames.ENRICH_SEARCH]: {
    darkIcon: imagePath.light.selected.enrichSearchIcon,
    lightIcon: imagePath.light.action.enrichSearchLightIcon,
  },
  [imageNames.ADS_CLICK]: {
    darkIcon: imagePath.neutral.common.adsClick,
    lightIcon: imagePath.neutral.common.adsClick,
  },
  [imageNames.WHITE_ENRICH_SEARCH]: {
    darkIcon: imagePath.dark.selected.whiteEnrichSearchIcon,
    lightIcon: imagePath.light.selected.whiteEnrichSearchLightIcon,
  },
  [imageNames.FILTER_GREY]: {
    darkIcon: imagePath.neutral.grey.filterIconGrey,
    lightIcon: imagePath.neutral.grey.filterIconGrey,
  },
  [imageNames.FILTER_ACTIVE]: {
    darkIcon: imagePath.dark.selected.filterActive,
    lightIcon: imagePath.light.selected.filterActiveLightIcon,
  },
  [imageNames.FILTER_SELECTED]: {
    darkIcon: imagePath.dark.selected.filterIconSelected,
    lightIcon: imagePath.dark.selected.filterIconSelected,
  },
  [imageNames.CHEVRON_ARROW_LEFT_GREY]: {
    darkIcon: imagePath.neutral.arrows.chevronArrowLeftGrey,
    lightIcon: imagePath.neutral.arrows.chevronArrowLeftGrey,
  },
  [imageNames.CHEVRON_ARROW_RIGHT]: {
    darkIcon: imagePath.dark.arrows.chevronArrowRight,
    lightIcon: imagePath.chevronArrowRightLightIcon,
  },
  [imageNames.DISCORD]: {
    darkIcon: imagePath.neutral.icon.discordIcon,
    lightIcon: imagePath.discordLightIcon,
  },
  [imageNames.ADD_BLACK]: {
    darkIcon: imagePath.neutral.action.addIconBlack,
    lightIcon: imagePath.neutral.action.addIconBlack,
  },
  [imageNames.MORE_VERTICAL]: {
    darkIcon: imagePath.dark.selected.moreIconVertical,
    lightIcon: imagePath.light.selected.moreIconVerticalLightIcon,
  },
  [imageNames.MORE_VERTICAL_DISABLED]: {
    darkIcon: imagePath.dark.unselected.moreIconVerticalDisabled,
    lightIcon: imagePath.light.unselected.moreIconVerticalDisabledLightIcon,
  },
  [imageNames.EDIT]: {
    darkIcon: imagePath.neutral.grey.editIcon,
    lightIcon: imagePath.neutral.grey.editIcon,
  },
  [imageNames.CLONE_GREY]: {
    darkIcon: imagePath.neutral.grey.cloneIconGrey,
    lightIcon: imagePath.neutral.grey.cloneIconGrey,
  },
  [imageNames.ZOOM_ICON]: {
    darkIcon: imagePath.neutral.icon.zoomIcon,
    lightIcon: imagePath.neutral.icon.zoomIcon,
  },
  [imageNames.DELETE_GREY]: {
    darkIcon: imagePath.neutral.grey.deleteIconGrey,
    lightIcon: imagePath.neutral.grey.deleteIconGrey,
  },
  [imageNames.CLOSE_GREY]: {
    darkIcon: imagePath.neutral.grey.closeIconGrey,
    lightIcon: imagePath.neutral.grey.closeIconGrey,
  },
  [imageNames.EMAIL_GREY]: {
    darkIcon: imagePath.neutral.grey.emailIconGrey,
    lightIcon: imagePath.neutral.grey.emailIconGrey,
  },
  [imageNames.CHANNEL_EMAIL]: {
    darkIcon: imagePath.dark.common.channelEmail,
    lightIcon: imagePath.light.common.channelEmail,
  },
  [imageNames.CHANNEL_WHATSAPP]: {
    darkIcon: imagePath.dark.selected.whatsappSelectedDarkIcon,
    lightIcon: imagePath.neutral.grey.whatsappIconGrey,
  },
  [imageNames.CONTACTS_LEADS]: {
    darkIcon: imagePath.dark.call.contactsLeadsIcon,
    lightIcon: imagePath.light.selected.contactsLeadsLightIcon,
  },
  [imageNames.CALL_GREY]: {
    darkIcon: imagePath.neutral.grey.callIconGrey,
    lightIcon: imagePath.neutral.grey.callIconGrey,
  },
  [imageNames.WHATSAPP_GREY]: {
    darkIcon: imagePath.neutral.grey.whatsappIconGrey,
    lightIcon: imagePath.neutral.grey.whatsappIconGrey,
  },
  [imageNames.ACTION]: {
    darkIcon: imagePath.light.selected.actionIcon,
    lightIcon: imagePath.light.selected.actionIcon,
  },
  [imageNames.MEETING_GREY]: {
    darkIcon: imagePath.neutral.grey.meetingIconGrey,
    lightIcon: imagePath.neutral.grey.meetingIconGrey,
  },
  [imageNames.NOTE]: {
    darkIcon: imagePath.dark.selected.noteIcon,
    lightIcon: imagePath.light.selected.noteLightIcon,
  },
  [imageNames.TASK]: {
    darkIcon: imagePath.dark.selected.taskIcon,
    lightIcon: imagePath.light.selected.taskLightIcon,
  },
  [imageNames.LINKEDIN_SELECTED]: {
    darkIcon: imagePath.dark.icon.suitcaseDarkIcon,
    lightIcon: imagePath.light.icon.suitcaseLightIcon,
  },
  [imageNames.LINKEDIN_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.linkedinUnSelectedIcon,
    lightIcon: imagePath.neutral.unselected.linkedinUnSelectedIcon,
  },
  [imageNames.MARK_AS_DONE]: {
    darkIcon: imagePath.dark.selected.checkIconRoundedWhiteEmpty,
    lightIcon: imagePath.light.action.markAsDoneLightIcon,
  },
  [imageNames.MARKED_AS_DONE]: {
    darkIcon: imagePath.neutral.info.markedAsDoneIcon,
    lightIcon: imagePath.neutral.info.markedAsDoneIcon,
  },
  [imageNames.LEFT_ARROW]: {
    darkIcon: imagePath.dark.arrows.leftArrowIcon,
    lightIcon: imagePath.light.arrows.leftArrowLightIcon,
  },
  [imageNames.LEFT_ARROW_GREY]: {
    darkIcon: imagePath.neutral.arrows.leftArrowGreyIcon,
    lightIcon: imagePath.neutral.arrows.leftArrowGreyIcon,
  },
  [imageNames.LEFT_ARROW_WHITE]: {
    darkIcon: imagePath.dark.arrows.leftArrowIcon,
    lightIcon: imagePath.dark.arrows.leftArrowIcon,
  },
  [imageNames.RIGHT_ARROW]: {
    darkIcon: imagePath.dark.arrows.rightArrowIcon,
    lightIcon: imagePath.light.arrows.rightArrowLightIcon,
  },
  [imageNames.EMPTY_SCREEN_GREY]: {
    darkIcon: imagePath.emptyScreenGreyDarkIcon,
    lightIcon: imagePath.emptyScreenGreyLightIcon,
  },
  [imageNames.CHART_AND_TABLE_EMPTY_SCREEN_GREY]: {
    darkIcon: imagePath.chartAndTableEmptyScreenGreyDarkIcon,
    lightIcon: imagePath.chartAndTableEmptyScreenGreyLightIcon,
  },
  [imageNames.CALL_LOGS_EMPTY_SCREEN_GREY]: {
    darkIcon: imagePath.callLogsEmptyScreenGreyDarkIcon,
    lightIcon: imagePath.callLogsEmptyScreenGreyLightIcon,
  },
  [imageNames.CALL_QUALITY_EMPTY_SCREEN_GREY]: {
    darkIcon: imagePath.callQualityEmptyScreenGreyDarkIcon,
    lightIcon: imagePath.callQualityEmptyScreenGreyLightIcon,
  },
  [imageNames.CALL_CAMPAIGNS_EMPTY_SCREEN]: {
    darkIcon: imagePath.dark.empty.callCampaigns,
    lightIcon: imagePath.light.empty.callCampaigns,
  },
  [imageNames.SUPER_AGI_EMPTY_BOLT]: {
    darkIcon: platformPath.dark.empty.superAGIBolt,
    lightIcon: platformPath.light.empty.superAGIBolt,
  },
  [imageNames.APOLLO]: {
    darkIcon: imagePath.apolloIcon,
    lightIcon: imagePath.apolloIcon,
  },
  [imageNames.SENDSPARK]: {
    darkIcon: imagePath.neutral.icon.sendsparkIcon,
    lightIcon: imagePath.neutral.icon.sendsparkIcon,
  },
  [imageNames.HORIZONTAL_THREE_DOTS]: {
    darkIcon: imagePath.dark.action.horizontalThreeDots,
    lightIcon: imagePath.light.action.horizontalThreeDotsLightIcon,
  },
  [imageNames.HORIZONTAL_THREE_DOTS_GREY]: {
    darkIcon: imagePath.neutral.grey.horizontalThreeDotsGrey,
    lightIcon: imagePath.neutral.grey.horizontalThreeDotsGrey,
  },
  [imageNames.BACK_ARROW_DEFAULT_GREY]: {
    darkIcon: imagePath.neutral.arrows.backArrowDefaultGrey,
    lightIcon: imagePath.neutral.arrows.backArrowDefaultGrey,
  },
  [imageNames.BACK_ARROW_WHITE]: {
    darkIcon: imagePath.dark.arrows.backArrowWhite,
    lightIcon: imagePath.light.arrows.backArrowWhiteLightIcon,
  },
  [imageNames.BACK_ARROW_VARIANT1_GREY]: {
    darkIcon: imagePath.neutral.arrows.backArrowVariant1Grey,
    lightIcon: imagePath.neutral.arrows.backArrowVariant1Grey,
  },
  [imageNames.PIPELINES_SELECTED]: {
    darkIcon: imagePath.dark.selected.pipelinesSelectedIcon,
    lightIcon: imagePath.light.selected.pipelinesSelectedLightIcon,
  },
  [imageNames.PIPELINES_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.pipelinesUnselectedIcon,
    lightIcon: imagePath.neutral.unselected.pipelinesUnselectedIcon,
  },
  [imageNames.REPLY]: {
    darkIcon: imagePath.dark.action.replyIcon,
    lightIcon: imagePath.light.action.replyLightIcon,
  },
  [imageNames.REPLY_ALL]: {
    darkIcon: imagePath.dark.action.replyAllIcon,
    lightIcon: imagePath.light.action.replyAllLightIcon,
  },
  [imageNames.FORWARD]: {
    darkIcon: imagePath.dark.action.forwardIcon,
    lightIcon: imagePath.light.action.forwardLightIcon,
  },
  [imageNames.FORWARD_GREY]: {
    darkIcon: imagePath.dark.action.forwardGreyIcon,
    lightIcon: imagePath.light.action.forwardGreyIcon,
  },
  [imageNames.GROUP]: {
    darkIcon: imagePath.groupIcon,
    lightIcon: imagePath.groupIcon,
  },
  [imageNames.NEW_CHAT]: {
    darkIcon: imagePath.newChatIcon,
    lightIcon: imagePath.newChatIcon,
  },
  [imageNames.WORKSPACE_SPECIAL_CHAR_ICON]: {
    darkIcon: imagePath.workspaceSpecialCharIcon,
    lightIcon: imagePath.workspaceSpecialCharIcon,
  },
  [imageNames.NULL_ENTITY_PLACEHOLDER]: {
    darkIcon: imagePath.nullEntityPlaceholder,
    lightIcon: imagePath.nullEntityPlaceholder,
  },
  [imageNames.SEND_WHITE]: {
    darkIcon: imagePath.dark.action.sendIconWhite,
    lightIcon: imagePath.light.action.sendIconBlack,
  },
  [imageNames.SEND_BLACK]: {
    darkIcon: imagePath.light.action.sendIconBlack,
    lightIcon: imagePath.dark.action.sendIconWhite,
  },
  [imageNames.SEARCH_EMPTY_SCREEN_GREY]: {
    darkIcon: imagePath.searchEmptyScreenGrey,
    lightIcon: imagePath.light.action.searchEmptyScreenGreyLightIcon,
  },
  [imageNames.TABLE_VIEW_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.tableViewUnselected,
    lightIcon: imagePath.neutral.unselected.tableViewUnselected,
  },
  [imageNames.TABLE_VIEW_SELECTED]: {
    darkIcon: imagePath.dark.selected.tableViewSelected,
    lightIcon: imagePath.light.selected.tableViewSelectedLightIcon,
  },
  [imageNames.KANBAN_VIEW_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.kanbanViewUnselected,
    lightIcon: imagePath.neutral.unselected.kanbanViewUnselected,
  },
  [imageNames.KANBAN_VIEW_SELECTED]: {
    darkIcon: imagePath.dark.selected.kanbanViewSelected,
    lightIcon: imagePath.light.selected.kanbanViewSelectedLightIcon,
  },
  [imageNames.HIGH_PRIORITY]: {
    darkIcon: imagePath.neutral.info.highPriority,
    lightIcon: imagePath.neutral.info.highPriority,
  },
  [imageNames.LOW_PRIORITY]: {
    darkIcon: imagePath.neutral.info.lowPriority,
    lightIcon: imagePath.neutral.info.lowPriority,
  },
  [imageNames.MEDIUM_PRIORITY]: {
    darkIcon: imagePath.neutral.info.mediumPriority,
    lightIcon: imagePath.neutral.info.mediumPriority,
  },
  [imageNames.PLUS]: {
    darkIcon: imagePath.dark.action.plusIcon,
    lightIcon: imagePath.light.action.plusLightIcon,
  },
  [imageNames.REMOVE_GREY]: {
    darkIcon: imagePath.neutral.grey.removeIconGrey,
    lightIcon: imagePath.neutral.grey.removeIconGrey,
  },
  [imageNames.TICK_GREY]: {
    darkIcon: imagePath.neutral.grey.tickIconGrey,
    lightIcon: imagePath.neutral.grey.tickIconGrey,
  },
  [imageNames.TICK_WHITE]: {
    darkIcon: imagePath.dark.selected.tickIconWhite,
    lightIcon: imagePath.light.action.tickIconWhiteLightIcon,
  },
  [imageNames.BOLD_TICK_GREY]: {
    darkIcon: imagePath.neutral.grey.boldTickIconGrey,
    lightIcon: imagePath.neutral.grey.boldTickIconGrey,
  },
  [imageNames.MANUAL_GREY]: {
    darkIcon: imagePath.neutral.grey.manualIconGrey,
    lightIcon: imagePath.neutral.grey.manualIconGrey,
  },
  [imageNames.ADD]: {
    darkIcon: imagePath.dark.selected.addIcon,
    lightIcon: imagePath.light.action.addLightIcon,
  },
  [imageNames.COMPLETE_CAMPAIGN_STEP]: {
    darkIcon: imagePath.dark.selected.completeCampaignStep,
    lightIcon: imagePath.light.selected.completeCampaignStepLightIcon,
  },
  [imageNames.PROGRESS_CAMPAIGN_STEP]: {
    darkIcon: imagePath.dark.selected.progressCampaignStep,
    lightIcon: imagePath.light.selected.progressCampaignStepLightIcon,
  },
  [imageNames.REMAINING_CAMPAIGN_STEP]: {
    darkIcon: imagePath.dark.action.remainingCampaignStep,
    lightIcon: imagePath.light.action.remainingCampaignStepLightIcon,
  },
  [imageNames.PREVIEW_LEADS]: {
    darkIcon: imagePath.dark.selected.previewLeads,
    lightIcon: imagePath.light.selected.previewLeadsLightIcon,
  },
  [imageNames.DUSTBIN_GREY]: {
    darkIcon: imagePath.neutral.grey.dustbinIconGrey,
    lightIcon: imagePath.neutral.grey.dustbinIconGrey,
  },
  [imageNames.EMAIL_STEP]: {
    darkIcon: imagePath.dark.action.emailStep,
    lightIcon: imagePath.light.action.emailStepLightIcon,
  },
  [imageNames.QUESTION_MARK]: {
    darkIcon: imagePath.dark.action.questionMark,
    lightIcon: imagePath.light.action.questionMarkLightIcon,
  },
  [imageNames.AGI_MARK]: {
    darkIcon: imagePath.neutral.platform.agiMark,
    lightIcon: imagePath.neutral.platform.agiMark,
  },
  [imageNames.AUTOMATION]: {
    darkIcon: imagePath.dark.action.automation,
    lightIcon: imagePath.light.action.automation,
  },
  [imageNames.ARROW_DOWN_TOOLTIP_GREY]: {
    darkIcon: imagePath.neutral.arrows.arrowDownTooltipGrey,
    lightIcon: imagePath.neutral.arrows.arrowDownTooltipGrey,
  },
  [imageNames.AGI_PURPLE]: {
    darkIcon: imagePath.neutral.platform.agiMark,
    lightIcon: imagePath.neutral.platform.agiMark,
  },
  [imageNames.CALENDAR_EDIT_GREY]: {
    darkIcon: imagePath.neutral.grey.calendarEditGrey,
    lightIcon: imagePath.neutral.grey.calendarEditGrey,
  },
  [imageNames.CROSS_MARK]: {
    darkIcon: imagePath.neutral.action.crossMark,
    lightIcon: imagePath.neutral.action.crossMark,
  },
  [imageNames.TICK_MARK]: {
    darkIcon: imagePath.neutral.action.tickMark,
    lightIcon: imagePath.neutral.action.tickMark,
  },
  [imageNames.NO_TEMPLATE_GREY]: {
    darkIcon: imagePath.neutral.grey.noTemplateIconGrey,
    lightIcon: imagePath.neutral.grey.noTemplateIconGrey,
  },
  [imageNames.MAIL_GREY]: {
    darkIcon: imagePath.neutral.grey.mailIconGrey,
    lightIcon: imagePath.neutral.grey.mailIconGrey,
  },
  [imageNames.CURLY_BRACE_GREY]: {
    darkIcon: imagePath.neutral.grey.curlyBraceIconGrey,
    lightIcon: imagePath.neutral.grey.curlyBraceIconGrey,
  },
  [imageNames.CURLY_BRACE_WITH_LIGHTNING_GREY]: {
    darkIcon: imagePath.neutral.platform.curlyBraceWithLightningIcon,
    lightIcon: imagePath.neutral.platform.curlyBraceWithLightningIcon,
  },
  [imageNames.STACKED_EMAIL_GREY]: {
    darkIcon: imagePath.neutral.grey.stackedEmailGrey,
    lightIcon: imagePath.neutral.grey.stackedEmailGrey,
  },
  [imageNames.SETTINGS_GREY]: {
    darkIcon: imagePath.neutral.grey.settingsIconGrey,
    lightIcon: imagePath.neutral.grey.settingsIconGrey,
  },
  [imageNames.SETTINGS_ICON]: {
    darkIcon: imagePath.dark.action.settings,
    lightIcon: imagePath.light.action.settings,
  },
  [imageNames.TUNE]: {
    darkIcon: imagePath.dark.action.tune,
    lightIcon: imagePath.light.action.tune,
  },
  [imageNames.LOGOUT_GREY]: {
    darkIcon: imagePath.neutral.grey.logoutIconGrey,
    lightIcon: imagePath.neutral.grey.logoutIconGrey,
  },
  [imageNames.ADD_GREY]: {
    darkIcon: imagePath.neutral.grey.addIconGrey,
    lightIcon: imagePath.neutral.grey.addIconGrey,
  },
  [imageNames.LINK]: {
    darkIcon: imagePath.dark.action.linkIcon,
    lightIcon: imagePath.light.action.linkLightIcon,
  },
  [imageNames.SORTING_ARROW_GREY]: {
    darkIcon: imagePath.dark.arrows.sortingArrowGrey,
    lightIcon: imagePath.light.arrows.sortingArrowGreyLightIcon,
  },
  [imageNames.SORTING_ARROW_SELECTED]: {
    darkIcon: imagePath.dark.arrows.sortingArrowSelected,
    lightIcon: imagePath.light.arrows.sortingArrowSelectedLightIcon,
  },
  [imageNames.EMOJI_GREY]: {
    darkIcon: imagePath.neutral.grey.emojiIconGrey,
    lightIcon: imagePath.neutral.grey.emojiIconGrey,
  },
  [imageNames.IS_TYPING]: {
    darkIcon: imagePath.dark.loaders.isTypingIcon,
    lightIcon: imagePath.light.loaders.isTypingLightIcon,
  },
  [imageNames.INFO]: {
    darkIcon: imagePath.dark.selected.infoIcon,
    lightIcon: imagePath.light.selected.infoLightIcon,
  },
  [imageNames.WARNING]: {
    darkIcon: imagePath.neutral.info.yellowWarning,
    lightIcon: imagePath.neutral.info.yellowWarning,
  },
  [imageNames.ANNOUNCEMENT]: {
    darkIcon: imagePath.neutral.info.blueAnnouncement,
    lightIcon: imagePath.neutral.info.blueAnnouncement,
  },
  [imageNames.GMAIL_LOGO]: {
    darkIcon: imagePath.neutral.integration.gmailLogo,
    lightIcon: imagePath.neutral.integration.gmailLogo,
  },
  [imageNames.EMAIL_BLACK]: {
    darkIcon: imagePath.light.selected.emailIconBlack,
    lightIcon: imagePath.light.action.emailIconBlackLightIcon,
  },
  [imageNames.NO_NOTIFICATIONS_GREY]: {
    darkIcon: imagePath.neutral.grey.noNotificationsIconGrey,
    lightIcon: imagePath.light.unselected.noNotificationsIconGreyLightIcon,
  },
  [imageNames.LINKEDIN_GREY]: {
    darkIcon: imagePath.dark.icon.suitcaseDarkIcon,
    lightIcon: imagePath.light.icon.suitcaseLightIcon,
  },
  [imageNames.SUITCASE_LIGHT]: {
    darkIcon: imagePath.dark.icon.suitcaseDarkIcon,
    lightIcon: imagePath.light.icon.suitcaseLightIcon,
  },
  [imageNames.SUITCASE_DARK]: {
    darkIcon: imagePath.dark.icon.suitcaseDarkIcon,
    lightIcon: imagePath.light.icon.suitcaseLightIcon,
  },
  [imageNames.LINKEDIN_STEP]: {
    darkIcon: imagePath.dark.icon.suitcaseDarkIcon,
    lightIcon: imagePath.light.icon.suitcaseLightIcon,
  },
  [imageNames.SMS_GREY]: {
    darkIcon: imagePath.neutral.grey.smsIconGrey,
    lightIcon: imagePath.neutral.grey.smsIconGrey,
  },
  [imageNames.COPY_GREY]: {
    darkIcon: imagePath.neutral.grey.copyIconGrey,
    lightIcon: imagePath.neutral.grey.copyIconGrey,
  },
  [imageNames.CHECK_BLACK]: {
    darkIcon: imagePath.dark.selected.checkIconBlack,
    lightIcon: imagePath.light.selected.checkIconBlackLightIcon,
  },
  [imageNames.ATTACH_FILE_GREY]: {
    darkIcon: imagePath.neutral.grey.attachFileIconGrey,
    lightIcon: imagePath.neutral.grey.attachFileIconGrey,
  },
  [imageNames.DOWNLOAD_GREY]: {
    darkIcon: imagePath.neutral.grey.downloadIconGrey,
    lightIcon: imagePath.neutral.grey.downloadIconGrey,
  },
  [imageNames.PRINT_GREY]: {
    darkIcon: imagePath.neutral.grey.printIconGrey,
    lightIcon: imagePath.neutral.grey.printIconGrey,
  },
  [imageNames.CAMPAIGN_TEMPLATES_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.campaignTemplatesUnselectedIcon,
    lightIcon: imagePath.neutral.unselected.campaignTemplatesUnselectedIcon,
  },
  [imageNames.CAMPAIGN_TEMPLATES_SELECTED]: {
    darkIcon: imagePath.dark.selected.campaignTemplatesSelectedIcon,
    lightIcon: imagePath.light.selected.campaignTemplatesSelectedLightIcon,
  },
  [imageNames.CONVERSATIONS_BLANK_GREY]: {
    darkIcon: imagePath.neutral.grey.conversationsBlankGrey,
    lightIcon: imagePath.light.selected.conversationsBlankGreyLightIcon,
  },
  [imageNames.OUTLOOK_LOGO]: {
    darkIcon: imagePath.neutral.integration.outlookLogo,
    lightIcon: imagePath.neutral.integration.outlookLogo,
  },
  [imageNames.CHECK]: {
    darkIcon: imagePath.dark.selected.checkIconRoundedWhite,
    lightIcon: imagePath.checkIconRoundedLightIcon,
  },
  [imageNames.SUPER_AGI_LOGO_ROUND]: {
    darkIcon: imagePath.neutral.platform.superAGILogoRound,
    lightIcon: imagePath.neutral.platform.superAGILogoRound,
  },
  [imageNames.UPLOAD_GREY]: {
    darkIcon: imagePath.neutral.grey.uploadIconGrey,
    lightIcon: imagePath.neutral.grey.uploadIconGrey,
  },
  [imageNames.CSV_FILE]: {
    darkIcon: imagePath.csvFileIcon,
    lightIcon: imagePath.csvFileIcon,
  },
  [imageNames.PREVIEW]: {
    darkIcon: imagePath.dark.selected.previewLeads,
    lightIcon: imagePath.light.selected.previewLightIcon,
  },
  [imageNames.MAILBOXES_SELECTED]: {
    darkIcon: imagePath.dark.selected.mailboxesSelected,
    lightIcon: imagePath.light.selected.mailboxesSelectedLightIcon,
  },
  [imageNames.MAILBOXES_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.mailboxesUnselected,
    lightIcon: imagePath.neutral.unselected.mailboxesUnselected,
  },
  [imageNames.GO_TO_LINK_GREY]: {
    darkIcon: imagePath.neutral.grey.goToLinkGrey,
    lightIcon: imagePath.neutral.grey.goToLinkGrey,
  },
  [imageNames.TRACKING_DOMAIN_SELECTED]: {
    darkIcon: imagePath.dark.selected.trackingDomainSelected,
    lightIcon: imagePath.light.selected.trackingDomainSelectedLightIcon,
  },
  [imageNames.TRACKING_DOMAIN_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.trackingDomainUnselected,
    lightIcon: imagePath.neutral.unselected.trackingDomainUnselected,
  },
  [imageNames.INFO_GREY]: {
    darkIcon: imagePath.neutral.grey.infoIconGrey,
    lightIcon: imagePath.neutral.grey.infoIconGrey,
  },
  [imageNames.PAUSE_GREY]: {
    darkIcon: imagePath.neutral.grey.pauseIconGrey,
    lightIcon: imagePath.neutral.grey.pauseIconGrey,
  },
  [imageNames.PAUSE_VARIANT1_ICON]: {
    darkIcon: imagePath.dark.action.pauseVariant1,
    lightIcon: imagePath.light.action.pauseVariant1,
  },
  [imageNames.GREEN_DOT]: {
    darkIcon: imagePath.neutral.info.greenDot,
    lightIcon: imagePath.neutral.info.greenDot,
  },
  [imageNames.ORANGE_DOT]: {
    darkIcon: imagePath.neutral.info.orangeDot,
    lightIcon: imagePath.neutral.info.orangeDot,
  },
  [imageNames.RED_DOT]: {
    darkIcon: imagePath.neutral.info.redDot,
    lightIcon: imagePath.neutral.info.redDot,
  },
  [imageNames.WHITE_DOT]: {
    darkIcon: imagePath.neutral.info.whiteDot,
    lightIcon: imagePath.light.selected.whiteDotLightIcon,
  },
  [imageNames.WARMUP]: {
    darkIcon: imagePath.dark.action.warmupIcon,
    lightIcon: imagePath.light.action.warmupLightIcon,
  },
  [imageNames.RESUME_BLACK]: {
    darkIcon: imagePath.dark.action.resumeIconBlack,
    lightIcon: imagePath.light.action.resumeIconBlackLightIcon,
  },
  [imageNames.RESUME_GREY]: {
    darkIcon: imagePath.neutral.action.resumeIconGrey,
    lightIcon: imagePath.light.action.resumeIconGreyLightIcon,
  },
  [imageNames.CHECK_GREEN]: {
    darkIcon: imagePath.neutral.info.checkGreenIcon,
    lightIcon: imagePath.neutral.info.checkGreenIcon,
  },
  [imageNames.ERROR]: {
    darkIcon: imagePath.neutral.info.redInfo,
    lightIcon: imagePath.neutral.info.redInfo,
  },
  [imageNames.CLOCK]: {
    darkIcon: imagePath.dark.selected.clockIcon,
    lightIcon: imagePath.light.selected.clockLightIcon,
  },
  [imageNames.RIGHT_ARROW_DEFAULT]: {
    darkIcon: imagePath.dark.arrows.rightArrowDefault,
    lightIcon: imagePath.light.arrows.rightArrowDefaultLightIcon,
  },
  [imageNames.WARNING_TRIANGLE]: {
    darkIcon: imagePath.neutral.alerts.warningIconTriangle,
    lightIcon: imagePath.neutral.alerts.warningIconTriangle,
  },
  [imageNames.ACTIVITY]: {
    darkIcon: imagePath.dark.selected.activityIcon,
    lightIcon: imagePath.light.selected.activityLightIcon,
  },
  [imageNames.ANALYTICS]: {
    darkIcon: imagePath.dark.selected.analyticsIcon,
    lightIcon: imagePath.light.selected.analyticsLightIcon,
  },
  [imageNames.OVERVIEW]: {
    darkIcon: imagePath.dark.action.overviewIcon,
    lightIcon: imagePath.light.selected.overviewLightIcon,
  },
  [imageNames.DEALS_GREY]: {
    darkIcon: imagePath.neutral.grey.dealsGreyIcon,
    lightIcon: imagePath.neutral.grey.dealsGreyIcon,
  },
  [imageNames.LEADS_GREY]: {
    darkIcon: imagePath.neutral.grey.leadsGreyIcon,
    lightIcon: imagePath.neutral.grey.leadsGreyIcon,
  },
  [imageNames.ADD_LIST_GREY]: {
    darkIcon: imagePath.neutral.icon.propertyTypeMultiSelect,
    lightIcon: imagePath.neutral.icon.propertyTypeMultiSelect,
  },
  [imageNames.AVAILABILITY_SELECTED]: {
    darkIcon: imagePath.dark.selected.availabilitySelected,
    lightIcon: imagePath.light.selected.availabilitySelectedLightIcon,
  },
  [imageNames.AVAILABILITY_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.availabilityUnselected,
    lightIcon: imagePath.neutral.unselected.availabilityUnselected,
  },
  [imageNames.REMOVE_LIST_GREY]: {
    darkIcon: imagePath.neutral.grey.removeListIconGrey,
    lightIcon: imagePath.neutral.grey.removeListIconGrey,
  },
  [imageNames.DROPDOWN_GREY]: {
    darkIcon: imagePath.neutral.arrows.downArrowIconGrey,
    lightIcon: imagePath.neutral.arrows.downArrowIconGrey,
  },
  [imageNames.LOCK_GREY]: {
    darkIcon: imagePath.neutral.grey.lockIconGrey,
    lightIcon: imagePath.neutral.grey.lockIconGrey,
  },
  [imageNames.LOCK_SELECTED]: {
    darkIcon: imagePath.dark.selected.lockSelectedIcon,
    lightIcon: imagePath.light.selected.lockSelectedLightIcon,
  },
  [imageNames.LOCK_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.lockUnselectedIcon,
    lightIcon: imagePath.neutral.unselected.lockUnselectedIcon,
  },
  [imageNames.CONTACTS_GREY]: {
    darkIcon: imagePath.neutral.grey.contactsGreyIcon,
    lightIcon: imagePath.neutral.grey.contactsGreyIcon,
  },
  [imageNames.CONTACTS_LEADS_GREY]: {
    darkIcon: imagePath.neutral.action.contactsLeadsGrey,
    lightIcon: imagePath.neutral.action.contactsLeadsGrey,
  },
  [imageNames.VALIDATION_GREEN_TICK]: {
    darkIcon: imagePath.neutral.action.validationGreenTick,
    lightIcon: imagePath.neutral.action.validationGreenTick,
  },

  [imageNames.VALIDATION_STEP_ERROR]: {
    darkIcon: imagePath.neutral.action.validationStepError,
    lightIcon: imagePath.neutral.action.validationStepError,
  },
  [imageNames.VALIDATION_WARNING]: {
    darkIcon: imagePath.neutral.info.yellowWarning,
    lightIcon: imagePath.neutral.info.yellowWarning,
  },
  [imageNames.COMPANIES_GREY]: {
    darkIcon: imagePath.neutral.grey.companiesGreyIcon,
    lightIcon: imagePath.neutral.grey.companiesGreyIcon,
  },
  [imageNames.AI_SDR_GREY]: {
    darkIcon: imagePath.neutral.grey.aiSDRGreyIcon,
    lightIcon: imagePath.neutral.grey.aiSDRGreyIcon,
  },
  [imageNames.EXPORT_GREY]: {
    darkIcon: imagePath.neutral.grey.exportIconGrey,
    lightIcon: imagePath.neutral.grey.exportIconGrey,
  },
  [imageNames.BOTTOM_ARROW_BLACK]: {
    darkIcon: imagePath.dark.arrows.bottomArrowBlackIcon,
    lightIcon: imagePath.light.arrows.bottomArrowBlackLightIcon,
  },
  [imageNames.RIGHT_ARROW_SMALL_GREY]: {
    darkIcon: imagePath.neutral.arrows.rightArrowSmallGrey,
    lightIcon: imagePath.neutral.arrows.rightArrowSmallGrey,
  },
  [imageNames.SIGNATURE_GREY]: {
    darkIcon: imagePath.neutral.grey.signatureIconGrey,
    lightIcon: imagePath.neutral.grey.signatureIconGrey,
  },
  [imageNames.ADD_ROUNDED_GREY]: {
    darkIcon: imagePath.neutral.grey.addRoundedGreyIcon,
    lightIcon: imagePath.neutral.grey.addRoundedGreyIcon,
  },
  [imageNames.LINK_GREY]: {
    darkIcon: imagePath.neutral.grey.linkGreyIcon,
    lightIcon: imagePath.neutral.grey.linkGreyIcon,
  },
  [imageNames.SEND_BLACK_FILLED]: {
    darkIcon: imagePath.dark.action.sendIconBlackFilled,
    lightIcon: imagePath.light.action.sendIconBlackFilledLightIcon,
  },
  [imageNames.SUPER_AGI_NAME_LOGO]: {
    darkIcon: imagePath.neutral.platform.superAgiNameLogo,
    lightIcon: imagePath.neutral.platform.superAgiNameLogo,
  },
  [imageNames.SUPER_AGI_NAME_FULL_LOGO]: {
    darkIcon: imagePath.neutral.platform.superAgiNameFullLogo,
    lightIcon: imagePath.neutral.platform.superAgiNameFullLogo,
  },
  [imageNames.ON_CALL]: {
    darkIcon: imagePath.dark.call.onCallIcon,
    lightIcon: imagePath.light.call.onCallLightIcon,
  },
  [imageNames.CALL_BLACK]: {
    darkIcon: imagePath.dark.call.callIconBlack,
    lightIcon: imagePath.light.call.callIconBlackLightIcon,
  },
  [imageNames.VIA_GREY]: {
    darkIcon: imagePath.neutral.grey.viaIconGrey,
    lightIcon: imagePath.neutral.grey.viaIconGrey,
  },
  [imageNames.STAR_GREY]: {
    darkIcon: imagePath.neutral.grey.starIconGrey,
    lightIcon: imagePath.neutral.grey.starIconGrey,
  },
  [imageNames.STAR_FILLED_GREY]: {
    darkIcon: imagePath.neutral.grey.starFilledIconGrey,
    lightIcon: imagePath.neutral.grey.starFilledIconGrey,
  },
  [imageNames.AT_THE_RATE_GREY]: {
    darkIcon: imagePath.neutral.grey.atTheRateIconGrey,
    lightIcon: imagePath.neutral.grey.atTheRateIconGrey,
  },
  [imageNames.AT_THE_RATE_SELECTED]: {
    darkIcon: imagePath.dark.selected.atTheRateSelectedIcon,
    lightIcon: imagePath.light.selected.atTheRateSelectedLightIcon,
  },
  [imageNames.BLOCK_LISTS_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.blockListsUnselected,
    lightIcon: imagePath.neutral.unselected.blockListsUnselected,
  },
  [imageNames.BLOCK_LISTS_SELECTED]: {
    darkIcon: imagePath.dark.selected.blockListsSelected,
    lightIcon: imagePath.light.selected.blockListsSelectedLightIcon,
  },
  [imageNames.ENCRYPTION_GREY]: {
    darkIcon: imagePath.neutral.grey.encryptionIconGrey,
    lightIcon: imagePath.neutral.grey.encryptionIconGrey,
  },
  [imageNames.RENAME]: {
    darkIcon: imagePath.dark.action.rename,
    lightIcon: imagePath.light.action.rename,
  },
  [imageNames.PROSPECTING_LINKEDIN_GREY]: {
    darkIcon: imagePath.dark.icon.suitcaseDarkIcon,
    lightIcon: imagePath.light.icon.suitcaseLightIcon,
  },
  [imageNames.LINKEDIN]: {
    darkIcon: imagePath.dark.icon.suitcaseDarkIcon,
    lightIcon: imagePath.light.icon.suitcaseLightIcon,
  },
  [imageNames.AUTOMATIC_EMAIL_GREY]: {
    darkIcon: imagePath.neutral.grey.automaticEmailGrey,
    lightIcon: imagePath.neutral.grey.automaticEmailGrey,
  },
  [imageNames.AUTOMATIC_EMAIL_WRAPPED]: {
    darkIcon: imagePath.neutral.common.automaticEmailWrapped,
    lightIcon: imagePath.neutral.common.automaticEmailWrapped,
  },
  [imageNames.EMAIL_WRAPPED]: {
    darkIcon: imagePath.dark.selected.emailIconWrapped,
    lightIcon: imagePath.light.selected.emailIconWrappedLightIcon,
  },
  [imageNames.LINK_ICON_GREY]: {
    darkIcon: imagePath.neutral.action.linkIconGrey,
    lightIcon: imagePath.neutral.action.linkIconGrey,
  },
  [imageNames.CALL_WRAPPED]: {
    darkIcon: imagePath.dark.call.callIconWrapped,
    lightIcon: imagePath.light.call.callIconWrappedLightIcon,
  },
  [imageNames.LINKEDIN_WRAPPED]: {
    darkIcon: imagePath.neutral.icon.linkedinWrapped,
    lightIcon: imagePath.neutral.icon.linkedinWrapped,
  },
  [imageNames.REMOVE_NOTE_GREY]: {
    darkIcon: imagePath.neutral.grey.removeNoteGrey,
    lightIcon: imagePath.neutral.grey.removeNoteGrey,
  },
  [imageNames.SELECT_MANUAL_GREY]: {
    darkIcon: imagePath.neutral.grey.selectManualIconGrey,
    lightIcon: imagePath.neutral.grey.selectManualIconGrey,
  },
  [imageNames.ORDERED_LIST_GREY]: {
    darkIcon: imagePath.neutral.grey.orderedListIconGrey,
    lightIcon: imagePath.neutral.grey.orderedListIconGrey,
  },
  [imageNames.PROSPECTING_BROWSER_GREY]: {
    darkIcon: imagePath.neutral.grey.prospectingBrowserIconGrey,
    lightIcon: imagePath.neutral.grey.prospectingBrowserIconGrey,
  },
  [imageNames.CRM_SYNC_GREY]: {
    darkIcon: imagePath.dark.common.crmSyncGreyDark,
    lightIcon: imagePath.light.unselected.crmSyncGreyLight,
  },
  [imageNames.EXPAND_GREY]: {
    darkIcon: imagePath.neutral.grey.expandIconGrey,
    lightIcon: imagePath.neutral.grey.expandIconGrey,
  },
  [imageNames.ADD_TO_SEQUENCE_GREY]: {
    darkIcon: imagePath.neutral.grey.addToSequenceGrey,
    lightIcon: imagePath.neutral.grey.addToSequenceGrey,
  },
  [imageNames.CODE_GREY]: {
    darkIcon: imagePath.neutral.grey.codeIconGrey,
    lightIcon: imagePath.neutral.grey.codeIconGrey,
  },
  [imageNames.EXPORT_SELECTED]: {
    darkIcon: imagePath.dark.selected.exportSelectedIcon,
    lightIcon: imagePath.light.selected.exportSelectedLightIcon,
  },
  [imageNames.EXPORT_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.exportUnSelectedIcon,
    lightIcon: imagePath.neutral.unselected.exportUnSelectedIcon,
  },
  [imageNames.CLICKED_ACTIVE]: {
    darkIcon: imagePath.dark.selected.clickedIconActive,
    lightIcon: imagePath.light.selected.clickedIconActiveLightIcon,
  },
  [imageNames.CLICKED_INACTIVE]: {
    darkIcon: imagePath.neutral.grey.clickedIconInactive,
    lightIcon: imagePath.light.unselected.clickedIconInactiveLightIcon,
  },
  [imageNames.DELIVERED_ACTIVE]: {
    darkIcon: imagePath.dark.action.deliveredIconActive,
    lightIcon: imagePath.light.selected.deliveredIconActiveLightIcon,
  },
  [imageNames.DELIVERED_INACTIVE]: {
    darkIcon: imagePath.neutral.grey.deliveredIconInactive,
    lightIcon: imagePath.light.unselected.deliveredIconInactiveLightIcon,
  },
  [imageNames.REPLIED_ACTIVE]: {
    darkIcon: imagePath.dark.selected.repliedIconActive,
    lightIcon: imagePath.light.selected.repliedIconActiveLightIcon,
  },
  [imageNames.REPLIED_INACTIVE]: {
    darkIcon: imagePath.dark.unselected.repliedIconInactive,
    lightIcon: imagePath.light.unselected.repliedIconInactiveLightIcon,
  },
  [imageNames.SEEN_ACTIVE]: {
    darkIcon: imagePath.dark.selected.seenIconActive,
    lightIcon: imagePath.light.selected.seenIconActiveLightIcon,
  },
  [imageNames.SEEN_INACTIVE]: {
    darkIcon: imagePath.dark.unselected.seenIconInactive,
    lightIcon: imagePath.light.unselected.seenIconInactiveLightIcon,
  },
  [imageNames.DISCONNECT_GREY]: {
    darkIcon: imagePath.neutral.grey.disconnectIconGrey,
    lightIcon: imagePath.neutral.grey.disconnectIconGrey,
  },
  [imageNames.USER]: {
    darkIcon: imagePath.dark.selected.userIcon,
    lightIcon: imagePath.light.selected.userLightIcon,
  },
  [imageNames.ROUND_ROBIN_GREY]: {
    darkIcon: imagePath.neutral.grey.roundRobinIconGrey,
    lightIcon: imagePath.neutral.grey.roundRobinIconGrey,
  },
  [imageNames.PROFILE_ICON_PLACEHOLDER]: {
    darkIcon: imagePath.dark.empty.profilePlaceholder,
    lightIcon: imagePath.light.empty.profilePlaceholder,
  },
  [imageNames.GOOGLE_MEET]: {
    darkIcon: imagePath.neutral.integration.googleMeetIcon,
    lightIcon: imagePath.neutral.integration.googleMeetIcon,
  },
  [imageNames.SUPER_MEET]: {
    darkIcon: imagePath.neutral.platform.superMeetIcon,
    lightIcon: imagePath.neutral.platform.superMeetIcon,
  },
  [imageNames.MS_TEAMS]: {
    darkIcon: imagePath.neutral.integration.msTeamsIcon,
    lightIcon: imagePath.neutral.integration.msTeamsIcon,
  },
  [imageNames.CALENDAR_GREY]: {
    darkIcon: imagePath.neutral.grey.calendarIconGrey,
    lightIcon: imagePath.neutral.grey.calendarIconGrey,
  },
  [imageNames.GOOGLE_CALENDAR]: {
    darkIcon: imagePath.neutral.integration.googleCalendarIcon,
    lightIcon: imagePath.neutral.integration.googleCalendarIcon,
  },
  [imageNames.OUTLOOK_CALENDAR]: {
    darkIcon: imagePath.neutral.integration.outlookCalendarIcon,
    lightIcon: imagePath.neutral.integration.outlookCalendarIcon,
  },
  [imageNames.INVERSE_GREY]: {
    darkIcon: imagePath.neutral.grey.inverseIconGrey,
    lightIcon: imagePath.neutral.grey.inverseIconGrey,
  },
  [imageNames.BROWSER]: {
    darkIcon: imagePath.dark.selected.domainSelected,
    lightIcon: imagePath.light.selected.browserLightIcon,
  },
  [imageNames.COPY_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.copyIconUnselected,
    lightIcon: imagePath.light.unselected.copyIconUnselectedLightIcon,
  },
  [imageNames.ASSIGN_OWNER_GREY]: {
    darkIcon: imagePath.neutral.grey.assignOwnerIconGrey,
    lightIcon: imagePath.neutral.grey.assignOwnerIconGrey,
  },
  [imageNames.ACTIVE_DOT]: {
    darkIcon: imagePath.dark.call.activeDot,
    lightIcon: imagePath.light.call.activeDotLightIcon,
  },
  [imageNames.INACTIVE_DOT]: {
    darkIcon: imagePath.neutral.info.inactiveDot,
    lightIcon: imagePath.light.call.inactiveDotLightIcon,
  },
  [imageNames.LOAD_BALANCING_GREY]: {
    darkIcon: imagePath.neutral.grey.loadBalancingIconGrey,
    lightIcon: imagePath.neutral.grey.loadBalancingIconGrey,
  },
  [imageNames.CALENDAR_TICK_GREY]: {
    darkIcon: imagePath.neutral.grey.calendarTickIconGrey,
    lightIcon: imagePath.neutral.grey.calendarTickIconGrey,
  },
  [imageNames.MINUS]: {
    darkIcon: imagePath.dark.action.minusIcon,
    lightIcon: imagePath.light.action.minusLightIcon,
  },
  [imageNames.OBJECT_SELECTED]: {
    darkIcon: imagePath.dark.selected.objectSelectedIcon,
    lightIcon: imagePath.light.selected.objectSelectedLightIcon,
  },
  [imageNames.OBJECT_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.objectUnselectedIcon,
    lightIcon: imagePath.neutral.unselected.objectUnselectedIcon,
  },
  [imageNames.ENCLOSED_CROSS_GREY]: {
    darkIcon: imagePath.neutral.grey.enclosedCrossGrey,
    lightIcon: imagePath.neutral.grey.enclosedCrossGrey,
  },
  [imageNames.CROSS_GREY]: {
    darkIcon: imagePath.neutral.grey.crossGreyIcon,
    lightIcon: imagePath.neutral.grey.crossGreyIcon,
  },
  [imageNames.BANNER_CROSS]: {
    darkIcon: imagePath.dark.action.bannerCrossIcon,
    lightIcon: imagePath.dark.action.bannerCrossIcon,
  },
  [imageNames.CHECK_ROUNDED_WHITE]: {
    darkIcon: imagePath.dark.selected.checkIconRoundedWhite,
    lightIcon: imagePath.light.selected.checkIconRoundedWhiteLightIcon,
  },
  [imageNames.CHECK_ROUNDED_WHITE_EMPTY]: {
    darkIcon: imagePath.dark.selected.checkIconRoundedWhiteEmpty,
    lightIcon: imagePath.light.selected.checkIconRoundedWhiteEmptyLightIcon,
  },
  [imageNames.CLOSE_VARIANT1]: {
    darkIcon: imagePath.dark.action.closeVariant1,
    lightIcon: imagePath.light.action.closeVariant1,
  },
  [imageNames.CLOSE_WHITE]: {
    darkIcon: imagePath.light.action.closeVariant1,
    lightIcon: imagePath.dark.action.closeVariant1,
  },
  [imageNames.UP_ARROW]: {
    darkIcon: imagePath.dark.arrows.upArrowIcon,
    lightIcon: imagePath.light.arrows.upArrowIconLightIcon,
  },
  [imageNames.DOWN_ARROW_WHITE]: {
    darkIcon: imagePath.dark.arrows.downArrowWhiteIcon,
    lightIcon: imagePath.light.arrows.downArrowWhiteLightIcon,
  },
  [imageNames.PREVIEW_EYE_GREY]: {
    darkIcon: imagePath.neutral.grey.previewEyeIconGrey,
    lightIcon: imagePath.neutral.grey.previewEyeIconGrey,
  },
  [imageNames.EMPTY_QUESTION_GREY]: {
    darkIcon: imagePath.emptyQuestionIconGrey,
    lightIcon: imagePath.emptyQuestionIconGrey,
  },
  [imageNames.BLACK_PLUS]: {
    darkIcon: imagePath.dark.action.blackPlusIcon,
    lightIcon: imagePath.light.selected.blackPlusLightIcon,
  },
  [imageNames.EMBED_ELEMENT]: {
    darkIcon: imagePath.neutral.card.embedElementIcon,
    lightIcon: imagePath.neutral.card.embedElementIcon,
  },
  [imageNames.EMBED_INLINE]: {
    darkIcon: imagePath.neutral.card.embedInlineIcon,
    lightIcon: imagePath.neutral.card.embedInlineIcon,
  },
  [imageNames.EMPTY_SIGNALS_GREY]: {
    darkIcon: imagePath.emptySignalsIconGrey,
    lightIcon: imagePath.emptySignalsIconGreyLight,
  },
  [imageNames.SIGNALS_LOW]: {
    darkIcon: imagePath.neutral.info.signalsLow,
    lightIcon: imagePath.neutral.info.signalsLow,
  },
  [imageNames.SIGNALS_HIGH]: {
    darkIcon: imagePath.neutral.info.signalsHigh,
    lightIcon: imagePath.neutral.info.signalsHigh,
  },
  [imageNames.SIGNALS_MEDIUM]: {
    darkIcon: imagePath.neutral.info.signalsMedium,
    lightIcon: imagePath.neutral.info.signalsMedium,
  },
  [imageNames.VIEW_DETAILS]: {
    darkIcon: imagePath.dark.action.viewDetailsIcon,
    lightIcon: imagePath.light.action.viewDetailsLightIcon,
  },
  [imageNames.VIEW_DETAILS_EXPAND_GREY]: {
    darkIcon: imagePath.neutral.grey.viewDetailsExpandIconGrey,
    lightIcon: imagePath.neutral.grey.viewDetailsExpandIconGrey,
  },
  [imageNames.ACCESS_FOLDER_GREY]: {
    darkIcon: imagePath.neutral.grey.accessFolderGreyIcon,
    lightIcon: imagePath.neutral.grey.accessFolderGreyIcon,
  },
  [imageNames.ATTACH_FILE_WHITE]: {
    darkIcon: imagePath.dark.selected.attachFileIconWhite,
    lightIcon: imagePath.light.action.attachFileIconWhiteLightIcon,
  },
  [imageNames.UPLOAD_1_GREY]: {
    darkIcon: imagePath.neutral.grey.uploadIcon1Grey,
    lightIcon: imagePath.neutral.grey.uploadIcon1Grey,
  },
  [imageNames.BOLD_WHITE]: {
    darkIcon: imagePath.dark.quill.boldIconWhite,
    lightIcon: imagePath.light.quill.boldIconWhiteLightIcon,
  },
  [imageNames.ITALIC_WHITE]: {
    darkIcon: imagePath.dark.quill.italicIconWhite,
    lightIcon: imagePath.light.quill.italicIconWhiteLightIcon,
  },
  [imageNames.UNDERLINE_WHITE]: {
    darkIcon: imagePath.dark.quill.underlineIconWhite,
    lightIcon: imagePath.light.quill.underlineIconWhiteLightIcon,
  },
  [imageNames.LINK_WHITE]: {
    darkIcon: imagePath.dark.quill.linkIconWhite,
    lightIcon: imagePath.light.quill.linkIconWhiteLightIcon,
  },
  [imageNames.QUOTE_WHITE]: {
    darkIcon: imagePath.dark.quill.quoteIconWhite,
    lightIcon: imagePath.light.quill.quoteIconWhiteLightIcon,
  },
  [imageNames.NUMBERED_LIST_WHITE]: {
    darkIcon: imagePath.dark.quill.numberedListIconWhite,
    lightIcon: imagePath.light.quill.numberedListIconWhiteLightIcon,
  },
  [imageNames.LIST_WHITE]: {
    darkIcon: imagePath.dark.quill.listIconWhite,
    lightIcon: imagePath.light.quill.listIconWhiteLightIcon,
  },
  [imageNames.LEFT_ALIGN_WHITE]: {
    darkIcon: imagePath.dark.quill.leftAlignIconWhite,
    lightIcon: imagePath.light.quill.leftAlignIconWhiteLightIcon,
  },
  [imageNames.RIGHT_ALIGN_WHITE]: {
    darkIcon: imagePath.dark.quill.rightAlignIconWhite,
    lightIcon: imagePath.light.quill.rightAlignIconWhiteLightIcon,
  },
  [imageNames.JUSTIFY_WHITE]: {
    darkIcon: imagePath.dark.quill.justifyIconWhite,
    lightIcon: imagePath.light.quill.justifyIconWhiteLightIcon,
  },
  [imageNames.ALIGN_CENTER_WHITE]: {
    darkIcon: imagePath.dark.quill.alignCenterIconWhite,
    lightIcon: imagePath.light.quill.alignCenterIconWhiteLightIcon,
  },
  [imageNames.LEFT_ALIGN]: {
    darkIcon: imagePath.light.quill.leftAlignIcon,
    lightIcon: imagePath.light.quill.leftAlignIcon,
  },
  [imageNames.IMAGE_WHITE]: {
    darkIcon: imagePath.dark.quill.imageIconWhite,
    lightIcon: imagePath.light.quill.imageIconWhiteLightIcon,
  },
  [imageNames.CLEAR_FORMATTING_WHITE]: {
    darkIcon: imagePath.dark.quill.clearFormattingIconWhite,
    lightIcon: imagePath.light.quill.clearFormattingIconWhiteLightIcon,
  },
  [imageNames.LIGHTNING]: {
    darkIcon: imagePath.neutral.platform.agiMark,
    lightIcon: imagePath.neutral.platform.agiMark,
  },
  [imageNames.BOOKMARK_GREY]: {
    darkIcon: imagePath.neutral.grey.bookmarkIconGrey,
    lightIcon: imagePath.neutral.grey.bookmarkIconGrey,
  },
  [imageNames.BILLING_GREY]: {
    darkIcon: imagePath.neutral.grey.billingIconGrey,
    lightIcon: imagePath.neutral.grey.billingIconGrey,
  },
  [imageNames.OPEN_IN_NEW_TAB_GREY]: {
    darkIcon: imagePath.neutral.grey.linkGreyIcon,
    lightIcon: imagePath.neutral.grey.linkGreyIcon,
  },
  [imageNames.FORM]: {
    darkIcon: imagePath.dark.selected.formIcon,
    lightIcon: imagePath.light.selected.formLightIcon,
  },
  [imageNames.REVOKE_GREY]: {
    darkIcon: imagePath.neutral.grey.revokeIconGrey,
    lightIcon: imagePath.neutral.grey.revokeIconGrey,
  },
  [imageNames.SWITCH_GREY]: {
    darkIcon: imagePath.neutral.grey.switchIconGrey,
    lightIcon: imagePath.neutral.grey.switchIconGrey,
  },
  [imageNames.NOT_ALLOWED_GREY]: {
    darkIcon: imagePath.neutral.grey.notAllowedIconGrey,
    lightIcon: imagePath.neutral.grey.notAllowedIconGrey,
  },
  [imageNames.UPLOAD_CSV_GREY]: {
    darkIcon: imagePath.neutral.grey.uploadCsvIconGrey,
    lightIcon: imagePath.neutral.grey.uploadCsvIconGrey,
  },
  [imageNames.CHECK_LIST_GREY]: {
    darkIcon: imagePath.neutral.grey.checkListIconGrey,
    lightIcon: imagePath.neutral.grey.checkListIconGrey,
  },
  [imageNames.MARKET_RESEARCH_GREY]: {
    darkIcon: imagePath.neutral.grey.marketResearchIconGrey,
    lightIcon: imagePath.neutral.grey.marketResearchIconGrey,
  },
  [imageNames.VOICE_AGENT_GREY]: {
    darkIcon: imagePath.dark.action.voiceAgent,
    lightIcon: imagePath.light.action.voiceAgentLight,
  },
  [imageNames.QUALIFICATION_GREY]: {
    darkIcon: imagePath.neutral.grey.qualificationIconGrey,
    lightIcon: imagePath.neutral.grey.qualificationIconGrey,
  },
  [imageNames.MULTI_THREADING_GREY]: {
    darkIcon: imagePath.neutral.grey.multiThreadingIconGrey,
    lightIcon: imagePath.neutral.grey.multiThreadingIconGrey,
  },
  [imageNames.NEXT_BEST_ACTION_GREY]: {
    darkIcon: imagePath.neutral.grey.nextBestActionIconGrey,
    lightIcon: imagePath.neutral.grey.nextBestActionIconGrey,
  },
  [imageNames.END_WHITE]: {
    darkIcon: imagePath.dark.selected.endIconWhite,
    lightIcon: imagePath.light.selected.endIconWhiteLightIcon,
  },
  [imageNames.DOCUMENT_GREY]: {
    darkIcon: imagePath.neutral.grey.documentIconGrey,
    lightIcon: imagePath.neutral.grey.documentIconGrey,
  },
  [imageNames.IMAGE_GREY]: {
    darkIcon: imagePath.neutral.grey.imageIconGrey,
    lightIcon: imagePath.neutral.grey.imageIconGrey,
  },
  [imageNames.VIDEO_GREY]: {
    darkIcon: imagePath.neutral.grey.videoIconGrey,
    lightIcon: imagePath.neutral.grey.videoIconGrey,
  },
  [imageNames.CAMERA_GREY]: {
    darkIcon: imagePath.neutral.grey.cameraIconGrey,
    lightIcon: imagePath.neutral.grey.cameraIconGrey,
  },
  [imageNames.SEND_GREY]: {
    darkIcon: imagePath.neutral.grey.sendIconGrey,
    lightIcon: imagePath.neutral.grey.sendIconGrey,
  },
  [imageNames.NOTE_GREY]: {
    darkIcon: imagePath.neutral.grey.noteIconGrey,
    lightIcon: imagePath.neutral.grey.noteIconGrey,
  },
  [imageNames.GO_TO_LINK_WHITE]: {
    darkIcon: imagePath.dark.action.goToLinkWhite,
    lightIcon: imagePath.light.action.goToLinkWhiteLightIcon,
  },
  [imageNames.APP_COLLECTION]: {
    darkIcon: imagePath.dark.selected.appCollection,
    lightIcon: imagePath.light.selected.appCollectionLightIcon,
  },
  [imageNames.ADD_STEP_GREY]: {
    darkIcon: imagePath.neutral.grey.addStepIconGrey,
    lightIcon: imagePath.neutral.grey.addStepIconGrey,
  },
  [imageNames.BACKSPACE_GREY]: {
    darkIcon: imagePath.neutral.grey.backspaceIconGrey,
    lightIcon: imagePath.neutral.grey.backspaceIconGrey,
  },
  [imageNames.CANCEL_GREY]: {
    darkIcon: imagePath.neutral.grey.cancelIconGrey,
    lightIcon: imagePath.neutral.grey.cancelIconGrey,
  },
  [imageNames.EXISTING_LEAD_GREY]: {
    darkIcon: imagePath.neutral.common.existingLeadIconGrey,
    lightIcon: imagePath.neutral.common.existingLeadIconGrey,
  },
  [imageNames.EXISTING_CONTACT_GREY]: {
    darkIcon: imagePath.neutral.common.existingContactIconGrey,
    lightIcon: imagePath.neutral.common.existingContactIconGrey,
  },
  [imageNames.SUPER_SALES_APP_LOGO]: {
    darkIcon: imagePath.neutral.platform.superSalesAppLogo,
    lightIcon: imagePath.neutral.platform.superSalesAppLogo,
  },
  [imageNames.APP_QR]: {
    darkIcon: imagePath.neutral.platform.appQr,
    lightIcon: imagePath.neutral.platform.appQr,
  },
  [imageNames.DOWNLOAD_FROM_GOOGLE_PLAY]: {
    darkIcon: imagePath.neutral.action.downloadFromGooglePlay,
    lightIcon: imagePath.neutral.action.downloadFromGooglePlay,
  },
  [imageNames.DOWNLOAD_FROM_APP_STORE]: {
    darkIcon: imagePath.neutral.action.downloadFromAppStore,
    lightIcon: imagePath.neutral.action.downloadFromAppStore,
  },
  [imageNames.SETUP_FORM]: {
    darkIcon: imagePath.dark.action.setupForm,
    lightIcon: imagePath.light.action.setupFormLightIcon,
  },
  [imageNames.DEFINE_ROUTING]: {
    darkIcon: imagePath.dark.action.defineRouting,
    lightIcon: imagePath.light.action.defineRoutingLightIcon,
  },
  [imageNames.RESPONSE_LOGS]: {
    darkIcon: imagePath.dark.selected.responseLogs,
    lightIcon: imagePath.light.selected.responseLogsLightIcon,
  },
  [imageNames.CLOSE_GREY_FILLED]: {
    darkIcon: imagePath.neutral.grey.closeIconGreyFilled,
    lightIcon: imagePath.neutral.grey.closeIconGreyFilled,
  },
  [imageNames.PROMPT]: {
    darkIcon: imagePath.dark.selected.promptIcon,
    lightIcon: imagePath.light.selected.promptLightIcon,
  },
  [imageNames.ROUNDED_QUESTION_MARK]: {
    darkIcon: imagePath.neutral.platform.roundedQuestionMark,
    lightIcon: imagePath.light.platform.roundedQuestionMarkLightIcon,
  },
  [imageNames.ADD_TASK_GREY]: {
    darkIcon: imagePath.neutral.grey.addTaskIconGrey,
    lightIcon: imagePath.neutral.grey.addTaskIconGrey,
  },
  [imageNames.API_KEYS_SELECTED]: {
    darkIcon: imagePath.dark.selected.apiKeysSelected,
    lightIcon: imagePath.light.selected.apiKeysSelectedLightIcon,
  },
  [imageNames.API_KEYS_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.apiKeysUnselected,
    lightIcon: imagePath.neutral.unselected.apiKeysUnselected,
  },
  [imageNames.CUSTOM_EVENTS_SELECTED]: {
    darkIcon: imagePath.dark.selected.customEventsSelected,
    lightIcon: imagePath.light.selected.customEventsSelectedLightIcon,
  },
  [imageNames.CUSTOM_EVENTS_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.customEventsUnselected,
    lightIcon: imagePath.neutral.unselected.customEventsUnselected,
  },
  [imageNames.ASSISTANT_SELECTED]: {
    darkIcon: sidebarImagePath.agiChatsSelectedIcon,
    lightIcon: sidebarImagePath.agiChatsSelectedLightIcon,
  },
  [imageNames.ASSISTANT_UNSELECTED]: {
    darkIcon: sidebarImagePath.agiChatsUnselectedIcon,
    lightIcon: sidebarImagePath.agiChatsUnselectedLightIcon,
  },
  [imageNames.GET_STARTED_SELECTED]: {
    darkIcon: sidebarImagePath.getStartedSelectedIcon,
    lightIcon: sidebarImagePath.getStartedSelectedLightIcon,
  },
  [imageNames.HOME_SELECTED]: {
    darkIcon: sidebarImagePath.homeSelectedIcon,
    lightIcon: sidebarImagePath.homeSelectedLightIcon,
  },
  [imageNames.HOME_UNSELECTED]: {
    darkIcon: sidebarImagePath.homeUnselectedIcon,
    lightIcon: sidebarImagePath.homeUnselectedLightIcon,
  },
  [imageNames.PROSPECT_SELECTED]: {
    darkIcon: sidebarImagePath.prospectSelectedIcon,
    lightIcon: sidebarImagePath.prospectSelectedLightIcon,
  },
  [imageNames.PROSPECT_UNSELECTED]: {
    darkIcon: sidebarImagePath.prospectUnselectedIcon,
    lightIcon: sidebarImagePath.prospectUnselectedLightIcon,
  },
  [imageNames.ENGAGE_SELECTED]: {
    darkIcon: sidebarImagePath.engageSelectedIcon,
    lightIcon: sidebarImagePath.engageSelectedLightIcon,
  },
  [imageNames.ENGAGE_UNSELECTED]: {
    darkIcon: sidebarImagePath.engageUnselectedIcon,
    lightIcon: sidebarImagePath.engageUnselectedLightIcon,
  },
  [imageNames.SEQUENCES_UNSELECTED]: {
    darkIcon: sidebarImagePath.sequencesUnselectedIcon,
    lightIcon: sidebarImagePath.sequencesUnselectedLightIcon,
  },
  [imageNames.CALL_UNSELECTED]: {
    darkIcon: sidebarImagePath.callUnselectedIcon,
    lightIcon: sidebarImagePath.callUnselectedLightIcon,
  },
  [imageNames.VOICE_AGENT_ICON]: {
    darkIcon: sidebarImagePath.voiceAgentSelectedIcon,
    lightIcon: sidebarImagePath.voiceAgentSelectedLightIcon,
  },
  [imageNames.BUILD_FROM_SCRATCH_ICON]: {
    darkIcon: imagePath.neutral.action.buildFromScratch,
    lightIcon: imagePath.neutral.action.buildFromScratch,
  },
  [imageNames.EDIT_SQUARE]: {
    darkIcon: imagePath.neutral.action.editSquare,
    lightIcon: imagePath.neutral.action.editSquare,
  },
  [imageNames.NUMBER_GREY]: {
    darkIcon: imagePath.neutral.action.numberGrey,
    lightIcon: imagePath.neutral.action.numberGrey,
  },
  [imageNames.BOOLEAN_GREY]: {
    darkIcon: imagePath.neutral.action.booleanGrey,
    lightIcon: imagePath.neutral.action.booleanGrey,
  },
  [imageNames.PLAY_ICON]: {
    darkIcon: imagePath.neutral.action.playIconGrey,
    lightIcon: imagePath.neutral.action.playIconGrey,
  },
  [imageNames.PAUSE_ICON]: {
    darkIcon: imagePath.neutral.grey.pauseIconGrey,
    lightIcon: imagePath.neutral.grey.pauseIconGrey,
  },
  [imageNames.CIRCLE_PLAY_ICON]: {
    darkIcon: imagePath.light.action.voiceAgentPlayLight,
    lightIcon: imagePath.light.action.voiceAgentPlayLight,
  },
  [imageNames.CIRCLE_PAUSE_ICON]: {
    darkIcon: imagePath.light.action.voiceAgentPauseLight,
    lightIcon: imagePath.light.action.voiceAgentPauseLight,
  },
  [imageNames.VOICE_AGENT_SELECTED]: {
    darkIcon: sidebarImagePath.voiceAgentSelectedIcon,
    lightIcon: sidebarImagePath.voiceAgentSelectedLightIcon,
  },
  [imageNames.VOICE_AGENT_UNSELECTED]: {
    darkIcon: sidebarImagePath.voiceAgentSelectedIcon,
    lightIcon: sidebarImagePath.voiceAgentSelectedLightIcon,
  },
  [imageNames.BUSINESS_RECEPTIONIST_SELECTED]: {
    darkIcon: sidebarImagePath.businessReceptionistDarkIcon,
    lightIcon: sidebarImagePath.businessReceptionistLightIcon,
  },
  [imageNames.BUSINESS_RECEPTIONIST_UNSELECTED]: {
    darkIcon: sidebarImagePath.businessReceptionistDarkIcon,
    lightIcon: sidebarImagePath.businessReceptionistLightIcon,
  },
  [imageNames.DIALER_PHONE_ICON]: {
    darkIcon: sidebarImagePath.callUnselectedIcon,
    lightIcon: sidebarImagePath.callUnselectedIcon,
  },
  [imageNames.CRM_SELECTED]: {
    darkIcon: sidebarImagePath.crmSelectedIcon,
    lightIcon: sidebarImagePath.crmSelectedLightIcon,
  },
  [imageNames.CRM_UNSELECTED]: {
    darkIcon: sidebarImagePath.crmUnselectedIcon,
    lightIcon: sidebarImagePath.crmUnselectedLightIcon,
  },
  [imageNames.CONTACTS_SELECTED]: {
    darkIcon: sidebarImagePath.contactsSelectedIcon,
    lightIcon: sidebarImagePath.contactsSelectedLightIcon,
  },
  [imageNames.CONTACTS_UNSELECTED]: {
    darkIcon: sidebarImagePath.contactsUnselectedIcon,
    lightIcon: sidebarImagePath.contactsUnselectedLightIcon,
  },
  [imageNames.COMPANIES_SELECTED]: {
    darkIcon: sidebarImagePath.companiesSelectedIcon,
    lightIcon: sidebarImagePath.companiesSelectedLightIcon,
  },
  [imageNames.COMPANIES_UNSELECTED]: {
    darkIcon: sidebarImagePath.companiesUnselectedIcon,
    lightIcon: sidebarImagePath.companiesUnselectedLightIcon,
  },
  [imageNames.LEADS_SELECTED]: {
    darkIcon: sidebarImagePath.leadsSelectedIcon,
    lightIcon: sidebarImagePath.leadsSelectedLightIcon,
  },
  [imageNames.LEADS_UNSELECTED]: {
    darkIcon: sidebarImagePath.leadsUnselectedIcon,
    lightIcon: sidebarImagePath.leadsUnselectedLightIcon,
  },
  [imageNames.DEALS_SELECTED]: {
    darkIcon: sidebarImagePath.dealsSelectedIcon,
    lightIcon: sidebarImagePath.dealsSelectedLightIcon,
  },
  [imageNames.DEALS_UNSELECTED]: {
    darkIcon: sidebarImagePath.dealsUnselectedIcon,
    lightIcon: sidebarImagePath.dealsUnselectedLightIcon,
  },
  [imageNames.INVOICES_SELECTED]: {
    darkIcon: sidebarImagePath.invoicesSelectedIcon,
    lightIcon: sidebarImagePath.invoicesSelectedLightIcon,
  },
  [imageNames.INVOICES_UNSELECTED]: {
    darkIcon: sidebarImagePath.invoicesUnselectedIcon,
    lightIcon: sidebarImagePath.invoicesUnselectedLightIcon,
  },
  [imageNames.PRODUCTS_SELECTED]: {
    darkIcon: sidebarImagePath.productsSelectedIcon,
    lightIcon: sidebarImagePath.productsSelectedLightIcon,
  },
  [imageNames.PRODUCTS_UNSELECTED]: {
    darkIcon: sidebarImagePath.productsUnselectedIcon,
    lightIcon: sidebarImagePath.productsUnselectedLightIcon,
  },
  [imageNames.LISTS_SELECTED]: {
    darkIcon: sidebarImagePath.listsSelectedIcon,
    lightIcon: sidebarImagePath.listsSelectedLightIcon,
  },
  [imageNames.LISTS_UNSELECTED]: {
    darkIcon: sidebarImagePath.listsUnselectedIcon,
    lightIcon: sidebarImagePath.listsUnselectedLightIcon,
  },
  [imageNames.ANALYSE_SELECTED]: {
    darkIcon: sidebarImagePath.analyseSelectedIcon,
    lightIcon: sidebarImagePath.analyseSelectedLightIcon,
  },
  [imageNames.ANALYSE_UNSELECTED]: {
    darkIcon: sidebarImagePath.analyseUnselectedIcon,
    lightIcon: sidebarImagePath.analyseUnselectedLightIcon,
  },
  [imageNames.AUTOMATE_SELECTED]: {
    darkIcon: sidebarImagePath.automateSelectedIcon,
    lightIcon: sidebarImagePath.automateSelectedLightIcon,
  },
  [imageNames.AUTOMATE_UNSELECTED]: {
    darkIcon: sidebarImagePath.automateUnselectedIcon,
    lightIcon: sidebarImagePath.automateUnselectedLightIcon,
  },
  [imageNames.NEW_TASKS_UNSELECTED]: {
    darkIcon: sidebarImagePath.dark.unselected.newTasksUnselectedIcon,
    lightIcon: sidebarImagePath.light.unselected.newTasksUnselectedLightIcon,
  },
  [imageNames.ACTIONS_UNSELECTED]: {
    darkIcon: sidebarImagePath.actionsUnselectedIcon,
    lightIcon: sidebarImagePath.actionsUnselectedLightIcon,
  },
  [imageNames.SIDEBAR_CONTENT_SELECTED]: {
    darkIcon: sidebarImagePath.contentSelectedIcon,
    lightIcon: sidebarImagePath.contentSelectedLightIcon,
  },
  [imageNames.DATA_ENRICHMENT_SELECTED]: {
    darkIcon: sidebarImagePath.dataEnrichmentSelectedIcon,
    lightIcon: sidebarImagePath.dataEnrichmentSelectedLightIcon,
  },
  [imageNames.DATA_ENRICHMENT_UNSELECTED]: {
    darkIcon: sidebarImagePath.dataEnrichmentUnselectedIcon,
    lightIcon: sidebarImagePath.dataEnrichmentUnselectedLightIcon,
  },
  [imageNames.SIGNALS_UNSELECTED]: {
    darkIcon: sidebarImagePath.signalsUnselectedIcon,
    lightIcon: sidebarImagePath.signalsUnselectedLightIcon,
  },
  [imageNames.SIGNALS_SELECTED]: {
    darkIcon: sidebarImagePath.signalsSelectedIcon,
    lightIcon: sidebarImagePath.signalsSelectedLightIcon,
  },
  [imageNames.REPORTS_UNSELECTED]: {
    darkIcon: sidebarImagePath.reportsUnselectedIcon,
    lightIcon: sidebarImagePath.reportsUnselectedLightIcon,
  },
  [imageNames.EMAIL_SELECTED]: {
    darkIcon: sidebarImagePath.emailSelectedIcon,
    lightIcon: sidebarImagePath.emailSelectedLightIcon,
  },
  [imageNames.EMAIL_UNSELECTED]: {
    darkIcon: sidebarImagePath.emailUnselectedIcon,
    lightIcon: sidebarImagePath.emailUnselectedLightIcon,
  },
  [imageNames.CONVERSATIONAL_INTELLIGENCE_SELECTED]: {
    darkIcon: sidebarImagePath.conversationalIntelligenceSelectedIcon,
    lightIcon: sidebarImagePath.conversationalIntelligenceSelectedLightIcon,
  },
  [imageNames.CONVERSATIONAL_INTELLIGENCE_UNSELECTED]: {
    darkIcon: sidebarImagePath.conversationalIntelligenceUnselectedIcon,
    lightIcon: sidebarImagePath.conversationalIntelligenceUnselectedLightIcon,
  },
  [imageNames.AGENT_BUILDER_SELECTED]: {
    darkIcon: sidebarImagePath.agentBuilderSelectedIcon,
    lightIcon: sidebarImagePath.agentBuilderSelectedLightIcon,
  },
  [imageNames.AGENT_BUILDER_UNSELECTED]: {
    darkIcon: sidebarImagePath.agentBuilderUnselectedIcon,
    lightIcon: sidebarImagePath.agentBuilderUnselectedLightIcon,
  },
  [imageNames.MEETINGS_SELECTED]: {
    darkIcon: sidebarImagePath.meetingsSelectedIcon,
    lightIcon: sidebarImagePath.meetingsSelectedLightIcon,
  },
  [imageNames.MEETINGS_UNSELECTED]: {
    darkIcon: sidebarImagePath.meetingsUnselectedIcon,
    lightIcon: sidebarImagePath.meetingsUnselectedLightIcon,
  },
  [imageNames.LIBRARY_SELECTED]: {
    darkIcon: sidebarImagePath.librarySelectedIcon,
    lightIcon: sidebarImagePath.librarySelectedLightIcon,
  },
  [imageNames.LIBRARY_UNSELECTED]: {
    darkIcon: sidebarImagePath.libraryUnselectedIcon,
    lightIcon: sidebarImagePath.libraryUnselectedLightIcon,
  },
  [imageNames.PROCESS_DESIGN_SELECTED]: {
    darkIcon: sidebarImagePath.processDesignSelectedIcon,
    lightIcon: sidebarImagePath.processDesignSelectedLightIcon,
  },
  [imageNames.PROCESS_DESIGN_UNSELECTED]: {
    darkIcon: sidebarImagePath.processDesignUnselectedIcon,
    lightIcon: sidebarImagePath.processDesignUnselectedLightIcon,
  },
  [imageNames.ESIGN_SELECTED]: {
    darkIcon: sidebarImagePath.esignSelectedIcon,
    lightIcon: sidebarImagePath.esignSelectedLightIcon,
  },
  [imageNames.ESIGN_UNSELECTED]: {
    darkIcon: sidebarImagePath.esignUnselectedIcon,
    lightIcon: sidebarImagePath.esignUnselectedLightIcon,
  },
  [imageNames.REFER]: {
    darkIcon: sidebarImagePath.referIcon,
    lightIcon: sidebarImagePath.referLightIcon,
  },
  [imageNames.ADD_MEMBER]: {
    darkIcon: sidebarImagePath.addMemberIcon,
    lightIcon: sidebarImagePath.addMemberLightIcon,
  },
  [imageNames.INSTALL_MOBILE]: {
    darkIcon: sidebarImagePath.installMobileIcon,
    lightIcon: sidebarImagePath.installMobileLightIcon,
  },
  [imageNames.BUSY_CALL]: {
    darkIcon: callImagePath.busyCall,
    lightIcon: callImagePath.busyCall,
  },
  [imageNames.GOING_CALL]: {
    darkIcon: callImagePath.goingCall,
    lightIcon: callImagePath.goingCall,
  },
  [imageNames.FORWARD_CALL]: {
    darkIcon: callImagePath.forwardCall,
    lightIcon: callImagePath.forwardCall,
  },
  [imageNames.VOICEMAIL_CALL]: {
    darkIcon: callImagePath.voicemailCall,
    lightIcon: callImagePath.voicemailCall,
  },
  [imageNames.TRANSFER_CALL]: {
    darkIcon: callImagePath.transferCall,
    lightIcon: callImagePath.transferCall,
  },
  [imageNames.CANCELLED_CALL]: {
    darkIcon: callImagePath.cancelledCall,
    lightIcon: callImagePath.cancelledCall,
  },
  [imageNames.POWER_DIALER_GREY]: {
    darkIcon: callImagePath.powerDialerGrey,
    lightIcon: callImagePath.powerDialerGrey,
  },
  [imageNames.PARALLEL_DIALER_GREY]: {
    darkIcon: callImagePath.parallelDialerGrey,
    lightIcon: callImagePath.parallelDialerGrey,
  },
  [imageNames.DIALER_SELECTED]: {
    darkIcon: callImagePath.dialerSelectedIcon,
    lightIcon: callImagePath.dialerSelectedLightIcon,
  },
  [imageNames.DIALER_UNSELECTED]: {
    darkIcon: callImagePath.dialerUnselectedIcon,
    lightIcon: callImagePath.dialerUnselectedLightIcon,
  },
  [imageNames.BUSINESS_PHONE_SELECTED]: {
    darkIcon: callImagePath.businessPhoneSelectedIcon,
    lightIcon: callImagePath.businessPhoneSelectedLightIcon,
  },
  [imageNames.BUSINESS_PHONE_UNSELECTED]: {
    darkIcon: callImagePath.businessPhoneUnselectedIcon,
    lightIcon: callImagePath.businessPhoneUnselectedLightIcon,
  },
  [imageNames.SALES_DIALER_SELECTED]: {
    darkIcon: callImagePath.salesDialerSelectedIcon,
    lightIcon: callImagePath.salesDialerSelectedLightIcon,
  },
  [imageNames.SALES_DIALER_UNSELECTED]: {
    darkIcon: callImagePath.salesDialerUnselectedIcon,
    lightIcon: callImagePath.salesDialerUnselectedLightIcon,
  },
  [imageNames.DIALER_NOTE_SELECTED]: {
    darkIcon: callImagePath.dialerNoteSelectedIcon,
    lightIcon: callImagePath.dialerNoteSelectedLightIcon,
  },
  [imageNames.DIALER_NOTE_UNSELECTED]: {
    darkIcon: callImagePath.dialerNoteUnselectedIcon,
    lightIcon: callImagePath.dialerNoteUnselectedLightIcon,
  },
  [imageNames.MUTE_SELECTED]: {
    darkIcon: callImagePath.muteSelectedIcon,
    lightIcon: callImagePath.muteSelectedLightIcon,
  },
  [imageNames.MUTE_UNSELECTED]: {
    darkIcon: callImagePath.muteUnselectedIcon,
    lightIcon: callImagePath.muteUnselectedLightIcon,
  },
  [imageNames.RECORD_SELECTED]: {
    darkIcon: callImagePath.recordSelectedIcon,
    lightIcon: callImagePath.recordSelectedLightIcon,
  },
  [imageNames.RECORD_UNSELECTED]: {
    darkIcon: callImagePath.recordUnselectedIcon,
    lightIcon: callImagePath.recordUnselectedLightIcon,
  },
  [imageNames.TRANSFER_SELECTED]: {
    darkIcon: callImagePath.transferSelectedIcon,
    lightIcon: callImagePath.transferSelectedLightIcon,
  },
  [imageNames.TRANSFER_UNSELECTED]: {
    darkIcon: callImagePath.transferUnselectedIcon,
    lightIcon: callImagePath.transferUnselectedLightIcon,
  },
  [imageNames.CALL_SWAP]: {
    darkIcon: callImagePath.callSwapIcon,
    lightIcon: callImagePath.callSwapLightIcon,
  },
  [imageNames.PHONE_NUMBERS_SELECTED]: {
    darkIcon: callImagePath.phoneNumbersSelectedIcon,
    lightIcon: callImagePath.phoneNumbersSelectedLightIcon,
  },
  [imageNames.PHONE_NUMBERS_UNSELECTED]: {
    darkIcon: callImagePath.phoneNumbersUnselectedIcon,
    lightIcon: callImagePath.phoneNumbersUnselectedIcon,
  },
  [imageNames.DIALER_SETTINGS_SELECTED]: {
    darkIcon: callImagePath.dialerSettingsSelectedIcon,
    lightIcon: callImagePath.dialerSettingsSelectedLightIcon,
  },
  [imageNames.DIALER_SETTINGS_UNSELECTED]: {
    darkIcon: callImagePath.dialerSettingsUnselectedIcon,
    lightIcon: callImagePath.dialerSettingsUnselectedIcon,
  },
  [imageNames.CALL_ROUTING_SELECTED]: {
    darkIcon: callImagePath.callRoutingSelectedIcon,
    lightIcon: callImagePath.callRoutingSelectedLightIcon,
  },
  [imageNames.CALL_ROUTING_UNSELECTED]: {
    darkIcon: callImagePath.callRoutingUnselectedIcon,
    lightIcon: callImagePath.callRoutingUnselectedIcon,
  },
  [imageNames.CALL_DISPOSITION_SELECTED]: {
    darkIcon: callImagePath.callDispositionSelectedIcon,
    lightIcon: callImagePath.callDispositionSelectedLightIcon,
  },
  [imageNames.CALL_DISPOSITION_UNSELECTED]: {
    darkIcon: callImagePath.callDispositionUnselectedIcon,
    lightIcon: callImagePath.callDispositionUnselectedLightIcon,
  },
  [imageNames.RECORD_ICON]: {
    darkIcon: callImagePath.recordIcon,
    lightIcon: callImagePath.recordIcon,
  },
  [imageNames.RECORDING_ICON]: {
    darkIcon: callImagePath.recordingIcon,
    lightIcon: callImagePath.recordingIcon,
  },
  [imageNames.STOP_RECORDING_GREY]: {
    darkIcon: callImagePath.stopRecordingIconGrey,
    lightIcon: callImagePath.stopRecordingIconGrey,
  },
  [imageNames.TRANSCRIPT_GREY]: {
    darkIcon: callImagePath.transcriptIconGrey,
    lightIcon: callImagePath.transcriptIconGrey,
  },
  [imageNames.IN_PROGRESS_GREEN_TAG]: {
    darkIcon: callImagePath.inProgressGreenTag,
    lightIcon: callImagePath.inProgressGreenTag,
  },
  [imageNames.IN_PROGRESS_PURPLE_TAG]: {
    darkIcon: callImagePath.inProgressPurpleTag,
    lightIcon: callImagePath.inProgressPurpleTag,
  },
  [imageNames.VOICE_AGENT_PLAY]: {
    darkIcon: callImagePath.voiceAgentPlay,
    lightIcon: callImagePath.voiceAgentPlay,
  },
  [imageNames.DIAL_ICON]: {
    darkIcon: callImagePath.dialerUnselectedIcon,
    lightIcon: callImagePath.dialLightIcon,
  },
  [imageNames.DIALPAD_ICON]: {
    darkIcon: callImagePath.dialLightIcon,
    lightIcon: callImagePath.dialerSelectedLightIcon,
  },
  [imageNames.DARK_THEME_GREY]: {
    darkIcon: imagePath.neutral.grey.darkThemeIconGrey,
    lightIcon: imagePath.neutral.grey.darkThemeIconGrey,
  },
  [imageNames.AUTO_THEME_GREY]: {
    darkIcon: imagePath.neutral.grey.autoThemeIconGrey,
    lightIcon: imagePath.neutral.grey.autoThemeIconGrey,
  },
  [imageNames.LIGHT_THEME_GREY]: {
    darkIcon: imagePath.neutral.grey.lightThemeIconGrey,
    lightIcon: imagePath.neutral.grey.lightThemeIconGrey,
  },
  [imageNames.FLAG_US]: {
    darkIcon: imagePath.neutral.country.USFlag,
    lightIcon: imagePath.neutral.country.USFlag,
  },
  [imageNames.FLAG_CA]: {
    darkIcon: imagePath.neutral.country.CAFlag,
    lightIcon: imagePath.neutral.country.CAFlag,
  },
  [imageNames.FLAG_UK]: {
    darkIcon: imagePath.neutral.country.UKFlag,
    lightIcon: imagePath.neutral.country.UKFlag,
  },
  [imageNames.FLAG_NZ]: {
    darkIcon: imagePath.neutral.country.NZFlag,
    lightIcon: imagePath.neutral.country.NZFlag,
  },
  [imageNames.FLAG_CH]: {
    darkIcon: imagePath.neutral.country.CHFlag,
    lightIcon: imagePath.neutral.country.CHFlag,
  },
  [imageNames.FLAG_IN]: {
    darkIcon: imagePath.neutral.country.INFlag,
    lightIcon: imagePath.neutral.country.INFlag,
  },
  [imageNames.FLAG_AU]: {
    darkIcon: imagePath.neutral.country.AUFlag,
    lightIcon: imagePath.neutral.country.AUFlag,
  },
  [imageNames.FLAG_SG]: {
    darkIcon: imagePath.neutral.country.SGFlag,
    lightIcon: imagePath.neutral.country.SGFlag,
  },
  [imageNames.FLAG_BR]: {
    darkIcon: imagePath.neutral.country.BRFlag,
    lightIcon: imagePath.neutral.country.BRFlag,
  },
  [imageNames.FLAG_IE]: {
    darkIcon: imagePath.neutral.country.IEFlag,
    lightIcon: imagePath.neutral.country.IEFlag,
  },
  [imageNames.FLAG_MY]: {
    darkIcon: imagePath.neutral.country.MYFlag,
    lightIcon: imagePath.neutral.country.MYFlag,
  },
  [imageNames.FLAG_MULTILINGUAL]: {
    darkIcon: imagePath.neutral.country.multilingualFlag,
    lightIcon: imagePath.neutral.country.multilingualFlag,
  },
  [imageNames.WHAT_TO_TALK]: {
    darkIcon: callImagePath.whatToTalk,
    lightIcon: callImagePath.whatToTalkLightIcon,
  },
  [imageNames.ENTITY_SCORING_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.entityScoringUnselectedIcon,
    lightIcon: imagePath.neutral.unselected.entityScoringUnselectedIcon,
  },
  [imageNames.ENTITY_SCORING_SELECTED]: {
    darkIcon: imagePath.dark.selected.entityScoringSelectedIcon,
    lightIcon: imagePath.light.selected.entityScoringSelectedLightIcon,
  },
  [imageNames.CHART_LOADER]: {
    darkIcon: loaderPath.dark.chart,
    lightIcon: loaderPath.light.chart,
  },
  [imageNames.TABLE_LOADER]: {
    darkIcon: loaderPath.dark.table,
    lightIcon: loaderPath.light.table,
  },
  [imageNames.MORE_DOTS]: {
    darkIcon: imagePath.neutral.info.whiteDot,
    lightIcon: imagePath.neutral.info.blackDot,
  },
  [imageNames.OUTLINED_QUESTION_MARK]: {
    darkIcon: imagePath.dark.action.outlinedQuestionMark,
    lightIcon: imagePath.light.selected.outlinedQuestionMarkLightIcon,
  },
  [imageNames.DOMAIN_SELECTED]: {
    darkIcon: imagePath.dark.selected.domainSelected,
    lightIcon: imagePath.light.selected.domainSelectedLightIcon,
  },
  [imageNames.DOMAIN_UNSELECTED]: {
    darkIcon: imagePath.neutral.unselected.domainUnselected,
    lightIcon: imagePath.neutral.unselected.domainUnselected,
  },
  [imageNames.PROSPECT_SEARCH_ICON]: {
    darkIcon: imagePath.dark.action.prospectSearchDarkIcon,
    lightIcon: imagePath.light.selected.prospectSearchLightIcon,
  },
  [imageNames.TICK_ICON]: {
    darkIcon: imagePath.dark.selected.blackTickIcon,
    lightIcon: imagePath.dark.selected.tickIconWhite,
  },
  [imageNames.SYNC_ICON_GREY]: {
    darkIcon: imagePath.neutral.grey.syncIconGrey,
    lightIcon: imagePath.neutral.grey.syncIconGrey,
  },
  [imageNames.BUSINESS_NAME_ICON]: {
    darkIcon: imagePath.businessNameIcon,
    lightIcon: imagePath.businessNameIcon,
  },
  [imageNames.RETRY_ICON_GREY]: {
    darkIcon: imagePath.neutral.grey.retryIconGrey,
    lightIcon: imagePath.neutral.grey.retryIconGrey,
  },
  [imageNames.MEETINGS_TALKTIME_SELECTED]: {
    darkIcon: imagePath.meetings.dark.selected.talktime,
    lightIcon: imagePath.meetings.light.selected.talktime,
  },
  [imageNames.MEETINGS_TALKTIME_UNSELECTED]: {
    darkIcon: imagePath.meetings.dark.unselected.talktime,
    lightIcon: imagePath.meetings.light.unselected.talktime,
  },
  [imageNames.MEETINGS_TRANSCRIPT_SELECTED]: {
    darkIcon: imagePath.meetings.dark.selected.transcript,
    lightIcon: imagePath.meetings.light.selected.transcript,
  },
  [imageNames.MEETINGS_TRANSCRIPT_UNSELECTED]: {
    darkIcon: imagePath.meetings.dark.unselected.transcript,
    lightIcon: imagePath.meetings.light.unselected.transcript,
  },
  [imageNames.MEETINGS_INTELLIGENCE_SELECTED]: {
    darkIcon: imagePath.meetings.dark.selected.meetingIntelligence,
    lightIcon: imagePath.meetings.light.selected.meetingIntelligence,
  },
  [imageNames.MEETINGS_INTELLIGENCE_UNSELECTED]: {
    darkIcon: imagePath.meetings.dark.unselected.meetingIntelligence,
    lightIcon: imagePath.meetings.light.unselected.meetingIntelligence,
  },
  [imageNames.RECOMMENDED_PROSPECTS]: {
    darkIcon: imagePath.dark.action.recommendedProspectsDark,
    lightIcon: sidebarImagePath.findLeadsUnselectedLightIcon,
  },
  [imageNames.INBOUND_AGENT_SELECTED]: {
    darkIcon: imagePath.dark.selected.inboundAgent,
    lightIcon: imagePath.light.selected.inboundAgent,
  },
  [imageNames.INBOUND_AGENT_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.inboundAgent,
    lightIcon: imagePath.light.unselected.inboundAgent,
  },
  [imageNames.PROJECTS_SELECTED]: {
    darkIcon: sidebarImagePath.dark.selected.projects,
    lightIcon: sidebarImagePath.light.selected.projects,
  },
  [imageNames.PROJECTS_UNSELECTED]: {
    darkIcon: sidebarImagePath.dark.unselected.projects,
    lightIcon: sidebarImagePath.light.unselected.projects,
  },
  [imageNames.DASHBOARDS_SELECTED]: {
    darkIcon: sidebarImagePath.dark.selected.dashboards,
    lightIcon: sidebarImagePath.light.selected.dashboards,
  },
  [imageNames.DASHBOARDS_UNSELECTED]: {
    darkIcon: sidebarImagePath.dark.unselected.dashboards,
    lightIcon: sidebarImagePath.light.unselected.dashboards,
  },
  [imageNames.INBOX_SELECTED]: {
    darkIcon: imagePath.dark.selected.inbox,
    lightIcon: imagePath.light.selected.inbox,
  },
  [imageNames.INBOX_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.inbox,
    lightIcon: imagePath.light.unselected.inbox,
  },
  [imageNames.AGENT_INSTRUCTIONS_SELECTED]: {
    darkIcon: imagePath.dark.selected.agentInstructions,
    lightIcon: imagePath.light.selected.agentInstructions,
  },
  [imageNames.AGENT_INSTRUCTIONS_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.agentInstructions,
    lightIcon: imagePath.light.unselected.agentInstructions,
  },
  [imageNames.KNOWLEDGE_BASE_SELECTED]: {
    darkIcon: imagePath.dark.selected.knowledgeBase,
    lightIcon: imagePath.light.selected.knowledgeBase,
  },
  [imageNames.KNOWLEDGE_BASE_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.knowledgeBase,
    lightIcon: imagePath.light.unselected.knowledgeBase,
  },
  [imageNames.LIVE_CHAT_WIDGET_SELECTED]: {
    darkIcon: imagePath.dark.selected.liveChatWidget,
    lightIcon: imagePath.light.selected.liveChatWidget,
  },
  [imageNames.LIVE_CHAT_WIDGET_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.liveChatWidget,
    lightIcon: imagePath.light.unselected.liveChatWidget,
  },
  [imageNames.PROSPECT_EMPTY_SCREEN]: {
    darkIcon: imagePath.prospectEmptyScreenDark,
    lightIcon: imagePath.prospectEmptyScreenLight,
  },
  [imageNames.TO_LEFT_ARROW]: {
    darkIcon: imagePath.neutral.grey.toLeftArrow,
    lightIcon: imagePath.neutral.grey.toLeftArrow,
  },
  [imageNames.EXPORT_MAILBOX_ICON]: {
    darkIcon: imagePath.dark.action.exportMailboxDarkIcon,
    lightIcon: imagePath.light.selected.exportMailboxLightIcon,
  },
  [imageNames.SUPER_AGI_ACADEMY_ICON]: {
    darkIcon: imagePath.dark.internal.superAGIAcademy,
    lightIcon: imagePath.light.internal.superAGIAcademy,
  },
  [imageNames.NOTIFICATION]: {
    darkIcon: imagePath.dark.action.notifications,
    lightIcon: imagePath.light.action.notifications,
  },
  [imageNames.WHATS_NEW]: {
    darkIcon: imagePath.dark.action.whatsNew,
    lightIcon: imagePath.light.action.whatsNew,
  },
  [imageNames.CUSTOMERS_SELECTED]: {
    darkIcon: sidebarImagePath.customerDarkSelected,
    lightIcon: sidebarImagePath.customerLightSelected,
  },
  [imageNames.CUSTOMERS_UNSELECTED]: {
    darkIcon: sidebarImagePath.customerDarkUnselected,
    lightIcon: sidebarImagePath.customerLightUnselected,
  },
  [imageNames.REDIRECT_GRADIENT]: {
    darkIcon: imagePath.redirectGradientIcon,
    lightIcon: imagePath.redirectGradientIcon,
  },
  [imageNames.PLAY_VARIANT1_ICON]: {
    darkIcon: imagePath.dark.action.playIcon,
    lightIcon: imagePath.dark.action.playIcon,
  },
  [imageNames.PLAY_VARIANT2_ICON]: {
    darkIcon: imagePath.dark.action.playIcon,
    lightIcon: imagePath.light.action.playIcon,
  },
  [imageNames.EMAIL_VERIFIED_ICON]: {
    darkIcon: imagePath.neutral.action.emailVerifiedIcon,
    lightIcon: imagePath.neutral.action.emailVerifiedIcon,
  },
  [imageNames.EMAIL_UNVERIFIED_ICON]: {
    darkIcon: imagePath.neutral.action.emailUnverifiedIcon,
    lightIcon: imagePath.neutral.action.emailUnverifiedIcon,
  },
  [imageNames.EMAIL_ACTION]: {
    darkIcon: imagePath.dark.action.emailAction,
    lightIcon: imagePath.light.action.emailAction,
  },
  [imageNames.ENCRYPTED_SELECTED]: {
    darkIcon: imagePath.dark.selected.encrypted,
    lightIcon: imagePath.light.selected.encrypted,
  },
  [imageNames.ENCRYPTED_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.encrypted,
    lightIcon: imagePath.light.unselected.encrypted,
  },
  [imageNames.CONTENT_PASTE_SEARCH]: {
    darkIcon: imagePath.neutral.common.contentPasteSearch,
    lightIcon: imagePath.neutral.common.contentPasteSearch,
  },
  [imageNames.CHECK_CIRCLE_2]: {
    darkIcon: imagePath.neutral.common.checkCircle2,
    lightIcon: imagePath.neutral.common.checkCircle2,
  },
  [imageNames.BLOCK_RED]: {
    darkIcon: imagePath.neutral.common.blockRed,
    lightIcon: imagePath.neutral.common.blockRed,
  },
  [imageNames.REMOVED_USER]: {
    darkIcon: imagePath.neutral.common.removedUser,
    lightIcon: imagePath.neutral.common.removedUser,
  },
  [imageNames.CAMPAIGN_ICON]: {
    darkIcon: imagePath.dark.selected.campaignsIcon,
    lightIcon: imagePath.dark.selected.campaignsIcon,
  },
  [imageNames.MOBILE_ICON]: {
    darkIcon: imagePath.neutral.grey.mobileIcon,
    lightIcon: imagePath.neutral.grey.mobileIcon,
  },
  [imageNames.DESKTOP_ICON]: {
    darkIcon: imagePath.neutral.grey.desktopIcon,
    lightIcon: imagePath.neutral.grey.desktopIcon,
  },
  [imageNames.RECIPIENTS_ICON_GREY]: {
    darkIcon: imagePath.neutral.grey.recipientsIconGrey,
    lightIcon: imagePath.neutral.grey.recipientsIconGrey,
  },
  [imageNames.RECIPIENTS_ICON_WHITE]: {
    darkIcon: imagePath.dark.selected.recipientsIconWhite,
    lightIcon: imagePath.neutral.grey.recipientsIconGrey,
  },
  [imageNames.EMAIL_CAMPAIGN_ICON_WHITE]: {
    darkIcon: imagePath.dark.selected.emailCampaignWhiteIcon,
    lightIcon: imagePath.dark.selected.emailCampaignWhiteIcon,
  },
  [imageNames.MARKETING_SELECTED]: {
    darkIcon: sidebarImagePath.marketingSelectedDarkIcon,
    lightIcon: sidebarImagePath.light.selected.marketingSelectedLightIcon,
  },
  [imageNames.MARKETING_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.marketingUnselectedDarkIcon,
    lightIcon: imagePath.light.unselected.marketingUnSelectedLightIcon,
  },
  [imageNames.ECOMMERCE_MARKETING_SELECTED]: {
    darkIcon: sidebarImagePath.ecommerceMarketingSelectedDarkIcon,
    lightIcon: sidebarImagePath.ecommerceMarketingSelectedLightIcon,
  },
  [imageNames.ECOMMERCE_MARKETING_UNSELECTED]: {
    darkIcon: sidebarImagePath.ecommerceMarketingUnselectedDarkIcon,
    lightIcon: sidebarImagePath.ecommerceMarketingUnselectedLightIcon,
  },
  [imageNames.CAMPAIGNS_SELECTED]: {
    darkIcon: sidebarImagePath.campaignsSelectedDarkIcon,
    lightIcon: sidebarImagePath.campaignsSelectedLightIcon,
  },
  [imageNames.CAMPAIGNS_UNSELECTED]: {
    darkIcon: imagePath.campaignsUnselectedDarkIcon,
    lightIcon: imagePath.campaignsUnSelectedLightIcon,
  },
  [imageNames.WHATSAPP_SELECTED]: {
    darkIcon: imagePath.dark.selected.whatsappSelectedDarkIcon,
    lightIcon: imagePath.light.selected.whatsappSelectedLightIcon,
  },
  [imageNames.EMAIL_CAMPAIGN_SETTINGS_UNSELECTED]: {
    darkIcon: imagePath.neutral.grey.emailCampaignSettingsUnselectedIcon,
    lightIcon: imagePath.neutral.grey.emailCampaignSettingsUnselectedIcon,
  },
  [imageNames.EMAIL_CAMPAIGN_SETTINGS_SELECTED]: {
    darkIcon: imagePath.dark.selected.emailCampaignWhiteIcon,
    lightIcon: imagePath.light.selected.emailCampaignSettingsSelectedLightIcon,
  },
  [imageNames.RED_INFO]: {
    darkIcon: imagePath.neutral.info.redInfo,
    lightIcon: imagePath.neutral.info.redInfo,
  },
  [imageNames.YELLOW_WARNING]: {
    darkIcon: imagePath.neutral.info.yellowWarning,
    lightIcon: imagePath.neutral.info.yellowWarning,
  },
  [imageNames.WARNING_ICON]: {
    darkIcon: imagePath.neutral.info.warningIcon,
    lightIcon: imagePath.neutral.info.warningIcon,
  },
  [imageNames.TEXT_EDITOR]: {
    darkIcon: imagePath.dark.common.textEditor,
    lightIcon: imagePath.light.common.textEditor,
  },
  [imageNames.HTML_CODE]: {
    darkIcon: imagePath.dark.common.htmlCode,
    lightIcon: imagePath.light.common.htmlCode,
  },
  [imageNames.TEXT_EDITOR_GREY]: {
    darkIcon: imagePath.neutral.common.textEditorGrey,
    lightIcon: imagePath.neutral.common.textEditorGrey,
  },
  [imageNames.HTML_CODE_GREY]: {
    darkIcon: imagePath.neutral.common.htmlCodeGrey,
    lightIcon: imagePath.neutral.common.htmlCodeGrey,
  },
  [imageNames.REFER_GREY]: {
    darkIcon: imagePath.neutral.grey.referIconGrey,
    lightIcon: imagePath.neutral.grey.referIconGrey,
  },
  [imageNames.X_GRADIENT]: {
    darkIcon: imagePath.xIconGradient,
    lightIcon: imagePath.xIconGradient,
  },
  [imageNames.LINKEDIN_GRADIENT]: {
    darkIcon: imagePath.linkedinIconGradient,
    lightIcon: imagePath.linkedinIconGradient,
  },
  [imageNames.WHATSAPP_GRADIENT]: {
    darkIcon: imagePath.whatsappIconGradient,
    lightIcon: imagePath.whatsappIconGradient,
  },
  [imageNames.FACEBOOK_GRADIENT]: {
    darkIcon: imagePath.facebookIconGradient,
    lightIcon: imagePath.facebookIconGradient,
  },
  [imageNames.EMAIL_GRADIENT]: {
    darkIcon: imagePath.emailIconGradient,
    lightIcon: imagePath.emailIconGradient,
  },
  [imageNames.ONBOARDING_IMAGE]: {
    darkIcon: imagePath.neutral.platform.onboardingImage,
    lightIcon: imagePath.neutral.platform.onboardingImage,
  },
  [imageNames.PLUS_GREY]: {
    darkIcon: imagePath.neutral.action.plusGrey,
    lightIcon: imagePath.neutral.action.plusGrey,
  },
  [imageNames.ASSOCIATIONS]: {
    darkIcon: imagePath.dark.common.associations,
    lightIcon: imagePath.light.common.associations,
  },
  [imageNames.ASSOCIATIONS_GREY]: {
    darkIcon: imagePath.neutral.common.associations,
    lightIcon: imagePath.neutral.common.associations,
  },
  [imageNames.PROPERTIES]: {
    darkIcon: imagePath.dark.common.properties,
    lightIcon: imagePath.light.common.properties,
  },
  [imageNames.PROPERTIES_GREY]: {
    darkIcon: imagePath.neutral.common.properties,
    lightIcon: imagePath.neutral.common.properties,
  },
  [imageNames.PROPERTY_TYPE_TEXT]: {
    darkIcon: imagePath.neutral.icon.propertyTypeText,
    lightIcon: imagePath.neutral.icon.propertyTypeText,
  },
  [imageNames.PROPERTY_TYPE_NUMBER]: {
    darkIcon: imagePath.neutral.icon.propertyTypeNumber,
    lightIcon: imagePath.neutral.icon.propertyTypeNumber,
  },
  [imageNames.PROPERTY_TYPE_SELECT]: {
    darkIcon: imagePath.neutral.icon.propertyTypeSelect,
    lightIcon: imagePath.neutral.icon.propertyTypeSelect,
  },
  [imageNames.SHARE]: {
    darkIcon: imagePath.neutral.action.share,
    lightIcon: imagePath.neutral.action.share,
  },
  [imageNames.PERCENTAGE_GREY]: {
    darkIcon: imagePath.neutral.action.percentageGrey,
    lightIcon: imagePath.neutral.action.percentageGrey,
  },
  [imageNames.PROPERTY_TYPE_MULTI_SELECT]: {
    darkIcon: imagePath.neutral.icon.propertyTypeMultiSelect,
    lightIcon: imagePath.neutral.icon.propertyTypeMultiSelect,
  },
  [imageNames.PROPERTY_TYPE_DATE]: {
    darkIcon: imagePath.neutral.icon.propertyTypeDate,
    lightIcon: imagePath.neutral.icon.propertyTypeDate,
  },
  [imageNames.PROPERTY_TYPE_DATETIME]: {
    darkIcon: imagePath.neutral.icon.propertyTypeDatetime,
    lightIcon: imagePath.neutral.icon.propertyTypeDatetime,
  },
  [imageNames.PROPERTY_TYPE_URL]: {
    darkIcon: imagePath.neutral.icon.propertyTypeUrl,
    lightIcon: imagePath.neutral.icon.propertyTypeUrl,
  },
  [imageNames.PROPERTY_TYPE_EMAIL]: {
    darkIcon: imagePath.neutral.icon.propertyTypeEmail,
    lightIcon: imagePath.neutral.icon.propertyTypeEmail,
  },
  [imageNames.PROPERTY_TYPE_PHONE]: {
    darkIcon: imagePath.neutral.icon.propertyTypePhone,
    lightIcon: imagePath.neutral.icon.propertyTypePhone,
  },
  [imageNames.PROPERTY_TYPE_USER]: {
    darkIcon: imagePath.neutral.icon.propertyTypeUser,
    lightIcon: imagePath.neutral.icon.propertyTypeUser,
  },
  [imageNames.PROPERTY_TYPE_BOOLEAN]: {
    darkIcon: imagePath.neutral.icon.propertyTypeBoolean,
    lightIcon: imagePath.neutral.icon.propertyTypeBoolean,
  },
  [imageNames.AGI_ASSISTANT_LIGHTNING]: {
    darkIcon: imagePath.neutral.action.agiAssistantLightning,
    lightIcon: imagePath.neutral.action.agiAssistantLightning,
  },
  [imageNames.OPEN_IN_FULL_MODE]: {
    darkIcon: imagePath.neutral.grey.openInFullMode,
    lightIcon: imagePath.neutral.grey.openInFullMode,
  },
  [imageNames.OPEN_CHAT_SELECTED_ICON]: {
    darkIcon: imagePath.dark.action.openChat,
    lightIcon: imagePath.light.action.openChat,
  },
  [imageNames.OPEN_CHAT_UNSELECTED_ICON]: {
    darkIcon: imagePath.neutral.action.openChat,
    lightIcon: imagePath.neutral.action.openChat,
  },
  [imageNames.CLOSE_CHAT_SELECTED_ICON]: {
    darkIcon: imagePath.dark.action.closeChat,
    lightIcon: imagePath.light.action.closeChat,
  },
  [imageNames.CLOSE_CHAT_UNSELECTED_ICON]: {
    darkIcon: imagePath.neutral.action.closeChat,
    lightIcon: imagePath.neutral.action.closeChat,
  },
  [imageNames.SORT_ASCENDING_NEUTRAL]: {
    darkIcon: imagePath.neutral.action.sortAscendingNeutral,
    lightIcon: imagePath.neutral.action.sortAscendingNeutral,
  },
  [imageNames.SORT_DESCENDING_NEUTRAL]: {
    darkIcon: imagePath.neutral.action.sortDescendingNeutral,
    lightIcon: imagePath.neutral.action.sortDescendingNeutral,
  },
  [imageNames.MANAGE_COLUMNS]: {
    darkIcon: imagePath.neutral.common.manageColumnsIcon,
    lightIcon: imagePath.neutral.common.manageColumnsIcon,
  },
  [imageNames.ADD_MEMBER_OPTION]: {
    darkIcon: imagePath.neutral.action.addMemberOption,
    lightIcon: imagePath.neutral.action.addMemberOption,
  },
  [imageNames.PLUS_GREY_THIN]: {
    darkIcon: imagePath.neutral.action.plusGreyThin,
    lightIcon: imagePath.neutral.action.plusGreyThin,
  },
  [imageNames.EYE_OFF_GREY]: {
    darkIcon: imagePath.neutral.action.eyeOffIconGrey,
    lightIcon: imagePath.neutral.action.eyeOffIconGrey,
  },
  [imageNames.EYE_GREY]: {
    darkIcon: imagePath.neutral.action.eyeIconGrey,
    lightIcon: imagePath.neutral.action.eyeIconGrey,
  },
  [imageNames.REPLIED_ICON]: {
    darkIcon: imagePath.dark.action.replied,
    lightIcon: imagePath.light.action.replied,
  },
  [imageNames.APP_STORE]: {
    darkIcon: sidebarImagePath.appStoreDarkIcon,
    lightIcon: sidebarImagePath.appStoreLightIcon,
  },
  [imageNames.DOMAIN_GREY]: {
    darkIcon: imagePath.neutral.icon.domain,
    lightIcon: imagePath.neutral.icon.domain,
  },
  [imageNames.PIN]: {
    darkIcon: imagePath.neutral.action.pin,
    lightIcon: imagePath.neutral.action.pin,
  },
  [imageNames.UNPIN]: {
    darkIcon: imagePath.neutral.action.unpin,
    lightIcon: imagePath.neutral.action.unpin,
  },
  [imageNames.PANEL_PROJECT]: {
    darkIcon: imagePath.dark.action.panelProject,
    lightIcon: imagePath.light.action.panelProject,
  },
  [imageNames.PANEL_ANALYTICS]: {
    darkIcon: imagePath.dark.action.panelAnalytics,
    lightIcon: imagePath.light.action.panelAnalytics,
  },
  [imageNames.PANEL_PROPERTY]: {
    darkIcon: imagePath.dark.action.panelProperty,
    lightIcon: imagePath.light.action.panelProperty,
  },
  [imageNames.PANEL_NOTES]: {
    darkIcon: imagePath.dark.action.panelNotes,
    lightIcon: imagePath.light.action.panelNotes,
  },
  [imageNames.PANEL_REPOSITORY]: {
    darkIcon: imagePath.dark.action.panelRepository,
    lightIcon: imagePath.light.action.panelRepository,
  },
  [imageNames.PROJECT_GREY]: {
    darkIcon: imagePath.neutral.common.projectGrey,
    lightIcon: imagePath.neutral.common.projectGrey,
  },
  [imageNames.MORE_ICON_GREY]: {
    darkIcon: imagePath.neutral.action.moreIconGrey,
    lightIcon: imagePath.neutral.action.moreIconGrey,
  },
  [imageNames.EDIT_V2]: {
    darkIcon: imagePath.neutral.action.editV2,
    lightIcon: imagePath.neutral.action.editV2,
  },
  [imageNames.ARROW_OUTWARD]: {
    darkIcon: imagePath.neutral.action.arrowOutward,
    lightIcon: imagePath.neutral.action.arrowOutward,
  },
  [imageNames.WEBSITE_UNPUBLISH]: {
    darkIcon: imagePath.neutral.action.websiteUnpublish,
    lightIcon: imagePath.neutral.action.websiteUnpublish,
  },
  [imageNames.ACCEPTED_INACTIVE]: {
    darkIcon: imagePath.light.selected.acceptedIconInactive,
    lightIcon: imagePath.light.selected.acceptedIconInactive,
  },
  [imageNames.ACCEPTED_ACTIVE]: {
    darkIcon: imagePath.neutral.action.acceptedIconActive,
    lightIcon: imagePath.neutral.action.acceptedIconActive,
  },
  [imageNames.SENT_INACTIVE]: {
    darkIcon: imagePath.light.selected.sentIconInactive,
    lightIcon: imagePath.light.selected.sentIconInactive,
  },
  [imageNames.SENT_ACTIVE]: {
    darkIcon: imagePath.dark.selected.sentIconActive,
    lightIcon: imagePath.dark.selected.sentIconActive,
  },
  [imageNames.BOLT_ICON]: {
    darkIcon: imagePath.dark.platform.boltIcon,
    lightIcon: imagePath.dark.platform.boltIcon,
  },
  [imageNames.TABLE_GREY]: {
    darkIcon: imagePath.neutral.common.tableGrey,
    lightIcon: imagePath.neutral.common.tableGrey,
  },
  [imageNames.BOARD_GREY]: {
    darkIcon: imagePath.neutral.common.boardGrey,
    lightIcon: imagePath.neutral.common.boardGrey,
  },
  [imageNames.PROPERTY_VISIBILITY_GREY]: {
    darkIcon: imagePath.neutral.action.propertyVisibilityGrey,
    lightIcon: imagePath.neutral.action.propertyVisibilityGrey,
  },
  [imageNames.DASHBOARD_GREY]: {
    darkIcon: imagePath.neutral.action.dashboardGrey,
    lightIcon: imagePath.neutral.action.dashboardGrey,
  },
  [imageNames.CARDS_GREY]: {
    darkIcon: imagePath.neutral.action.cardsGrey,
    lightIcon: imagePath.neutral.action.cardsGrey,
  },
  [imageNames.CUSTOMER_SUCCESS_SELECTED]: {
    darkIcon: imagePath.customerSuccessDarkSelected,
    lightIcon: imagePath.customerSuccessLightSelected,
  },
  [imageNames.CUSTOMER_SUCCESS_UNSELECTED]: {
    darkIcon: imagePath.customerSuccessDarkUnselected,
    lightIcon: imagePath.customerSuccessLightUnselected,
  },
  [imageNames.SUPER_AGI_FILLED_BOLT]: {
    darkIcon: platformPath.neutral.single.superAGIFilledBolt,
    lightIcon: platformPath.neutral.single.superAGIFilledBolt,
  },
  [imageNames.SUPER_AGI_HOLLOW_BOLT]: {
    darkIcon: platformPath.neutral.single.superAGIHollowBolt,
    lightIcon: platformPath.neutral.single.superAGIHollowBolt,
  },
  [imageNames.HIERARCHY]: {
    darkIcon: imagePath.dark.common.hierarchy,
    lightIcon: imagePath.light.common.hierarchy,
  },
  [imageNames.HIERARCHY_GREY]: {
    darkIcon: imagePath.neutral.common.hierarchy,
    lightIcon: imagePath.neutral.common.hierarchy,
  },
  [imageNames.PARENT_OBJECT_GREY]: {
    darkIcon: imagePath.neutral.common.parentObject,
    lightIcon: imagePath.neutral.common.parentObject,
  },
  [imageNames.CHILD_OBJECT_GREY]: {
    darkIcon: imagePath.neutral.common.childObject,
    lightIcon: imagePath.neutral.common.childObject,
  },
  [imageNames.VIEW_AGENDA]: {
    darkIcon: imagePath.dark.action.viewAgenda,
    lightIcon: imagePath.light.action.viewAgenda,
  },
  [imageNames.SINGLE_COLUMN]: {
    darkIcon: imagePath.dark.layout.singleColumn,
    lightIcon: imagePath.light.layout.singleColumn,
  },
  [imageNames.DOUBLE_COLUMN]: {
    darkIcon: imagePath.dark.layout.doubleColumn,
    lightIcon: imagePath.light.layout.doubleColumn,
  },
  [imageNames.AI_CARD_ICON]: {
    darkIcon: imagePath.neutral.card.ai,
    lightIcon: imagePath.neutral.card.ai,
  },
  [imageNames.TABLE_CARD_ICON]: {
    darkIcon: imagePath.neutral.card.table,
    lightIcon: imagePath.neutral.card.table,
  },
  [imageNames.NUMBER_CARD_ICON]: {
    darkIcon: imagePath.neutral.card.number,
    lightIcon: imagePath.neutral.card.number,
  },
  [imageNames.GRAPH_CARD_ICON]: {
    darkIcon: imagePath.neutral.card.graph,
    lightIcon: imagePath.neutral.card.graph,
  },
  [imageNames.REORDER_ICON]: {
    darkIcon: imagePath.dark.action.reorder,
    lightIcon: imagePath.light.action.reorder,
  },
  [imageNames.SQL_ANALYTICS]: {
    darkIcon: imagePath.dark.analytics.type.sql,
    lightIcon: imagePath.light.analytics.type.sql,
  },
  [imageNames.MANUAL_ANALYTICS]: {
    darkIcon: imagePath.dark.analytics.type.manual,
    lightIcon: imagePath.light.analytics.type.manual,
  },
  [imageNames.AREA_CHART]: {
    darkIcon: imagePath.dark.analytics.chart.area,
    lightIcon: imagePath.light.analytics.chart.area,
  },
  [imageNames.DONUT_CHART]: {
    darkIcon: imagePath.dark.analytics.chart.donut,
    lightIcon: imagePath.light.analytics.chart.donut,
  },
  [imageNames.GAUGE_CHART]: {
    darkIcon: imagePath.dark.analytics.chart.gauge,
    lightIcon: imagePath.light.analytics.chart.gauge,
  },
  [imageNames.HORIZONTAL_CHART]: {
    darkIcon: imagePath.dark.analytics.chart.horizontal,
    lightIcon: imagePath.light.analytics.chart.horizontal,
  },
  [imageNames.KPI_CHART]: {
    darkIcon: imagePath.dark.analytics.chart.kpi,
    lightIcon: imagePath.light.analytics.chart.kpi,
  },
  [imageNames.LINE_CHART]: {
    darkIcon: imagePath.dark.analytics.chart.line,
    lightIcon: imagePath.light.analytics.chart.line,
  },
  [imageNames.PIE_CHART]: {
    darkIcon: imagePath.dark.analytics.chart.pie,
    lightIcon: imagePath.light.analytics.chart.pie,
  },
  [imageNames.SCATTER_CHART]: {
    darkIcon: imagePath.dark.analytics.chart.scatter,
    lightIcon: imagePath.light.analytics.chart.scatter,
  },
  [imageNames.TABLE_CHART]: {
    darkIcon: imagePath.dark.analytics.chart.table,
    lightIcon: imagePath.light.analytics.chart.table,
  },
  [imageNames.VERTICAL_CHART]: {
    darkIcon: imagePath.dark.analytics.chart.vertical,
    lightIcon: imagePath.light.analytics.chart.vertical,
  },
  [imageNames.PIVOT_TABLE]: {
    darkIcon: imagePath.dark.analytics.chart.pivotTable,
    lightIcon: imagePath.light.analytics.chart.pivotTable,
  },
  [imageNames.FUNNEL_CHART]: {
    darkIcon: imagePath.dark.analytics.chart.funnel,
    lightIcon: imagePath.light.analytics.chart.funnel,
  },
  [imageNames.ADD_PURPLE]: {
    darkIcon: imagePath.neutral.action.addPurpleIcon,
    lightIcon: imagePath.neutral.action.addPurpleIcon,
  },
  [imageNames.RESIZE]: {
    darkIcon: imagePath.neutral.action.resizeIcon,
    lightIcon: imagePath.neutral.action.resizeIcon,
  },
  [imageNames.MSG_91_ICON]: {
    darkIcon: imagePath.neutral.common.msg91,
    lightIcon: imagePath.neutral.common.msg91,
  },
  [imageNames.CUSTOMER_SUCCESS_SETTINGS_SELECTED]: {
    darkIcon: imagePath.customerSuccessSettingsSelectedDark,
    lightIcon: imagePath.customerSuccessSettingsSelectedLight,
  },
  [imageNames.CUSTOMER_SUCCESS_SETTINGS_UNSELECTED]: {
    darkIcon: imagePath.customerSuccessSettingsUnselectedDark,
    lightIcon: imagePath.customerSuccessSettingsUnselectedLight,
  },
  [imageNames.EMPTY_CHART_PLACEHOLDER]: {
    darkIcon: imagePath.dark.empty.chart,
    lightIcon: imagePath.light.empty.chart,
  },
  [imageNames.CALCULATE_GREY]: {
    darkIcon: imagePath.neutral.common.calculateGrey,
    lightIcon: imagePath.neutral.common.calculateGrey,
  },
  [imageNames.CLOCK_GREY]: {
    darkIcon: imagePath.neutral.common.clockGrey,
    lightIcon: imagePath.neutral.common.clockGrey,
  },
  [imageNames.CONVERSION_RATE]: {
    darkIcon: imagePath.neutral.action.conversionRate,
    lightIcon: imagePath.neutral.action.conversionRate,
  },
  [imageNames.COMPARE_ARROWS]: {
    darkIcon: imagePath.neutral.common.compareArrows,
    lightIcon: imagePath.neutral.common.compareArrows,
  },
  [imageNames.FORMS_SELECTED]: {
    darkIcon: sidebarImagePath.dark.selected.forms,
    lightIcon: sidebarImagePath.light.selected.forms,
  },
  [imageNames.FORMS_UNSELECTED]: {
    darkIcon: sidebarImagePath.dark.unselected.forms,
    lightIcon: sidebarImagePath.light.unselected.forms,
  },
  [imageNames.AI_QA_SELECTED]: {
    darkIcon: sidebarImagePath.dark.selected.aiQa,
    lightIcon: sidebarImagePath.light.selected.aiQa,
  },
  [imageNames.AI_QA_UNSELECTED]: {
    darkIcon: sidebarImagePath.dark.unselected.aiQa,
    lightIcon: sidebarImagePath.light.unselected.aiQa,
  },
  [imageNames.CHECK_CIRCLE_OUTLINED]: {
    darkIcon: imagePath.dark.action.checkCircleOutlined,
    lightIcon: imagePath.light.action.checkCircleOutlined,
  },
  [imageNames.CHECK_CIRCLE]: {
    darkIcon: imagePath.neutral.action.checkCircle,
    lightIcon: imagePath.neutral.action.checkCircle,
  },
  [imageNames.MOVE]: {
    darkIcon: imagePath.dark.action.move,
    lightIcon: imagePath.light.action.move,
  },
  [imageNames.UNIBOX_SETTINGS_SELECTED]: {
    darkIcon: imagePath.dark.selected.uniboxSettingsIcon,
    lightIcon: imagePath.light.selected.uniboxSettingsIcon,
  },
  [imageNames.UNIBOX_SETTINGS_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.uniboxSettingsIcon,
    lightIcon: imagePath.light.unselected.uniboxSettingsIcon,
  },
  [imageNames.UNIBOX_SELECTED]: {
    darkIcon: imagePath.dark.selected.uniboxIcon,
    lightIcon: imagePath.light.selected.uniboxIcon,
  },
  [imageNames.UNIBOX_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.uniboxIcon,
    lightIcon: imagePath.light.unselected.uniboxIcon,
  },
  [imageNames.DEVELOPER_TOOLS_SELECTED]: {
    darkIcon: imagePath.dark.selected.developerTools,
    lightIcon: imagePath.light.selected.developerTools,
  },
  [imageNames.DEVELOPER_TOOLS_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.developerTools,
    lightIcon: imagePath.light.unselected.developerTools,
  },
  [imageNames.SANDBOX_SELECTED]: {
    darkIcon: imagePath.dark.selected.sandbox,
    lightIcon: imagePath.light.selected.sandbox,
  },
  [imageNames.SANDBOX_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.sandbox,
    lightIcon: imagePath.light.unselected.sandbox,
  },
  [imageNames.PERSONAL_TOKENS_SELECTED]: {
    darkIcon: imagePath.dark.selected.personalTokens,
    lightIcon: imagePath.light.selected.personalTokens,
  },
  [imageNames.PERSONAL_TOKENS_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.personalTokens,
    lightIcon: imagePath.light.unselected.personalTokens,
  },
  [imageNames.SSH_KEYS_SELECTED]: {
    darkIcon: imagePath.dark.selected.sshKeys,
    lightIcon: imagePath.light.selected.sshKeys,
  },
  [imageNames.SSH_KEYS_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.sshKeys,
    lightIcon: imagePath.light.unselected.sshKeys,
  },
  [imageNames.REPO_SETTINGS_SELECTED]: {
    darkIcon: imagePath.dark.selected.repoSettings,
    lightIcon: imagePath.light.selected.repoSettings,
  },
  [imageNames.REPO_SETTINGS_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.repoSettings,
    lightIcon: imagePath.light.unselected.repoSettings,
  },
  [imageNames.REPO_BRANCHES_SELECTED]: {
    darkIcon: imagePath.dark.selected.repoBranches,
    lightIcon: imagePath.light.selected.repoBranches,
  },
  [imageNames.REPO_BRANCHES_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.repoBranches,
    lightIcon: imagePath.light.unselected.repoBranches,
  },
  [imageNames.REPO_WEBHOOKS_SELECTED]: {
    darkIcon: imagePath.dark.selected.repoWebhooks,
    lightIcon: imagePath.light.selected.repoWebhooks,
  },
  [imageNames.REPO_WEBHOOKS_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.repoWebhooks,
    lightIcon: imagePath.light.unselected.repoWebhooks,
  },
  [imageNames.REPO_RULESETS_SELECTED]: {
    darkIcon: imagePath.dark.selected.repoRulesets,
    lightIcon: imagePath.light.selected.repoRulesets,
  },
  [imageNames.REPO_RULESETS_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.repoRulesets,
    lightIcon: imagePath.light.unselected.repoRulesets,
  },
  [imageNames.CODE_REVIEWER_SELECTED]: {
    darkIcon: imagePath.dark.selected.codeReviewer,
    lightIcon: imagePath.light.selected.codeReviewer,
  },
  [imageNames.CODE_REVIEWER_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.codeReviewer,
    lightIcon: imagePath.light.unselected.codeReviewer,
  },
  [imageNames.ATS_SELECTED]: {
    darkIcon: imagePath.dark.selected.ats,
    lightIcon: imagePath.light.selected.ats,
  },
  [imageNames.ATS_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.ats,
    lightIcon: imagePath.light.unselected.ats,
  },
  [imageNames.PEOPLE_SELECTED]: {
    darkIcon: imagePath.dark.selected.people,
    lightIcon: imagePath.light.selected.people,
  },
  [imageNames.PEOPLE_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.people,
    lightIcon: imagePath.light.unselected.people,
  },
  [imageNames.PERFORM_SELECTED]: {
    darkIcon: imagePath.dark.selected.perform,
    lightIcon: imagePath.light.selected.perform,
  },
  [imageNames.PERFORM_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.perform,
    lightIcon: imagePath.light.unselected.perform,
  },
  [imageNames.TIME_OFF_SELECTED]: {
    darkIcon: imagePath.dark.selected.timeOff,
    lightIcon: imagePath.light.selected.timeOff,
  },
  [imageNames.TIME_OFF_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.timeOff,
    lightIcon: imagePath.light.unselected.timeOff,
  },
  [imageNames.ATTENDANCE_SELECTED]: {
    darkIcon: imagePath.dark.selected.attendance,
    lightIcon: imagePath.light.selected.attendance,
  },
  [imageNames.ATTENDANCE_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.attendance,
    lightIcon: imagePath.light.unselected.attendance,
  },
  [imageNames.APPROVALS_SELECTED]: {
    darkIcon: imagePath.dark.selected.approvals,
    lightIcon: imagePath.light.selected.approvals,
  },
  [imageNames.APPROVALS_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.approvals,
    lightIcon: imagePath.light.unselected.approvals,
  },
  [imageNames.HR_SELECTED]: {
    darkIcon: imagePath.dark.selected.hr,
    lightIcon: imagePath.light.selected.hr,
  },
  [imageNames.HR_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.hr,
    lightIcon: imagePath.light.unselected.hr,
  },
  [imageNames.ERROR_LOGGING_SELECTED]: {
    darkIcon: imagePath.dark.selected.errorLogging,
    lightIcon: imagePath.light.selected.errorLogging,
  },
  [imageNames.ERROR_LOGGING_UNSELECTED]: {
    darkIcon: imagePath.dark.unselected.errorLogging,
    lightIcon: imagePath.light.unselected.errorLogging,
  },
  [imageNames.MESSAGE]: {
    darkIcon: imagePath.neutral.action.message,
    lightIcon: imagePath.neutral.action.message,
  },
  [imageNames.CHAT_ACTION]: {
    darkIcon: imagePath.dark.chat.chat,
    lightIcon: imagePath.light.chat.chat,
  },
  [imageNames.MEETING_LINKS_SELECTED]: {
    darkIcon: sidebarImagePath.dark.selected.meetingLinks,
    lightIcon: sidebarImagePath.light.selected.meetingLinks,
  },
  [imageNames.MEETING_LINKS_UNSELECTED]: {
    darkIcon: sidebarImagePath.dark.unselected.meetingLinks,
    lightIcon: sidebarImagePath.light.unselected.meetingLinks,
  },
  [imageNames.MEETING_NOTETAKER_SELECTED]: {
    darkIcon: sidebarImagePath.dark.selected.meetingNoteTaker,
    lightIcon: sidebarImagePath.light.selected.meetingNoteTaker,
  },
  [imageNames.MEETING_NOTETAKER_UNSELECTED]: {
    darkIcon: sidebarImagePath.dark.unselected.meetingNoteTaker,
    lightIcon: sidebarImagePath.light.unselected.meetingNoteTaker,
  },
  [imageNames.MEETING_ROUTER_SELECTED]: {
    darkIcon: sidebarImagePath.dark.selected.meetingRouter,
    lightIcon: sidebarImagePath.light.selected.meetingRouter,
  },
  [imageNames.MEETING_ROUTER_UNSELECTED]: {
    darkIcon: sidebarImagePath.dark.unselected.meetingRouter,
    lightIcon: sidebarImagePath.light.unselected.meetingRouter,
  },
  [imageNames.CODER_SELECTED]: {
    darkIcon: sidebarImagePath.dark.selected.coder,
    lightIcon: sidebarImagePath.light.selected.coder,
  },
  [imageNames.CODER_UNSELECTED]: {
    darkIcon: sidebarImagePath.dark.unselected.coder,
    lightIcon: sidebarImagePath.light.unselected.coder,
  },
  [imageNames.MOBILE_APP_SELECTED]: {
    darkIcon: sidebarImagePath.dark.selected.mobileApp,
    lightIcon: sidebarImagePath.light.selected.mobileApp,
  },
  [imageNames.MOBILE_APP_UNSELECTED]: {
    darkIcon: sidebarImagePath.dark.unselected.mobileApp,
    lightIcon: sidebarImagePath.light.unselected.mobileApp,
  },
  [imageNames.LANDING_PAGE_SELECTED]: {
    darkIcon: sidebarImagePath.dark.selected.landingPage,
    lightIcon: sidebarImagePath.light.selected.landingPage,
  },
  [imageNames.LANDING_PAGE_UNSELECTED]: {
    darkIcon: sidebarImagePath.dark.unselected.landingPage,
    lightIcon: sidebarImagePath.light.unselected.landingPage,
  },
  [imageNames.GAME_2D_SELECTED]: {
    darkIcon: sidebarImagePath.dark.selected.game2d,
    lightIcon: sidebarImagePath.light.selected.game2d,
  },
  [imageNames.GAME_2D_UNSELECTED]: {
    darkIcon: sidebarImagePath.dark.unselected.game2d,
    lightIcon: sidebarImagePath.light.unselected.game2d,
  },
  [imageNames.GAME_3D_SELECTED]: {
    darkIcon: sidebarImagePath.dark.selected.game3d,
    lightIcon: sidebarImagePath.light.selected.game3d,
  },
  [imageNames.GAME_3D_UNSELECTED]: {
    darkIcon: sidebarImagePath.dark.unselected.game3d,
    lightIcon: sidebarImagePath.light.unselected.game3d,
  },
  [imageNames.VIBE_VIDEO_SELECTED]: {
    darkIcon: sidebarImagePath.dark.selected.vibeVideo,
    lightIcon: sidebarImagePath.light.selected.vibeVideo,
  },
  [imageNames.VIBE_VIDEO_UNSELECTED]: {
    darkIcon: sidebarImagePath.dark.unselected.vibeVideo,
    lightIcon: sidebarImagePath.light.unselected.vibeVideo,
  },
  [imageNames.DEVELOPER_CENTER_SELECTED]: {
    darkIcon: sidebarImagePath.dark.selected.developerCenter,
    lightIcon: sidebarImagePath.light.selected.developerCenter,
  },
  [imageNames.DEVELOPER_CENTER_UNSELECTED]: {
    darkIcon: sidebarImagePath.dark.unselected.developerCenter,
    lightIcon: sidebarImagePath.light.unselected.developerCenter,
  },
  [imageNames.DIGITAL_EMPLOYEES_SELECTED]: {
    darkIcon: sidebarImagePath.dark.selected.digitalEmployees,
    lightIcon: sidebarImagePath.light.selected.digitalEmployees,
  },
  [imageNames.DIGITAL_EMPLOYEES_UNSELECTED]: {
    darkIcon: sidebarImagePath.dark.unselected.digitalEmployees,
    lightIcon: sidebarImagePath.light.unselected.digitalEmployees,
  },
  [imageNames.INFERENCE_ROUTER_SELECTED]: {
    darkIcon: sidebarImagePath.dark.selected.inferenceRouter,
    lightIcon: sidebarImagePath.light.selected.inferenceRouter,
  },
  [imageNames.INFERENCE_ROUTER_UNSELECTED]: {
    darkIcon: sidebarImagePath.dark.unselected.inferenceRouter,
    lightIcon: sidebarImagePath.light.unselected.inferenceRouter,
  },
  [imageNames.LIVE_ASSIST_SELECTED]: {
    darkIcon: sidebarImagePath.dark.selected.liveAssist,
    lightIcon: sidebarImagePath.light.selected.liveAssist,
  },
  [imageNames.LIVE_ASSIST_UNSELECTED]: {
    darkIcon: sidebarImagePath.dark.unselected.liveAssist,
    lightIcon: sidebarImagePath.light.unselected.liveAssist,
  },
  [imageNames.APPLE_ICON]: {
    darkIcon: imagePath.dark.action.appleIcon,
    lightIcon: imagePath.light.action.appleIcon,
  },
  [imageNames.EXPAND_ICON]: {
    darkIcon: imagePath.dark.huddle.expandIcon,
    lightIcon: imagePath.light.huddle.expandIcon,
  },
  [imageNames.COLLAPSE_ICON]: {
    darkIcon: imagePath.dark.huddle.collapseIcon,
    lightIcon: imagePath.light.huddle.collapseIcon,
  },
  [imageNames.MUTE_ICON]: {
    darkIcon: imagePath.dark.huddle.muteIcon,
    lightIcon: imagePath.light.huddle.muteIcon,
  },
  [imageNames.VIDEO_ICON]: {
    darkIcon: imagePath.dark.huddle.videoIcon,
    lightIcon: imagePath.light.huddle.videoIcon,
  },
  [imageNames.SCREEN_SHARE_ICON]: {
    darkIcon: imagePath.dark.huddle.screenShareIcon,
    lightIcon: imagePath.light.huddle.screenShareIcon,
  },
  [imageNames.MUTED_ICON]: {
    darkIcon: imagePath.neutral.huddle.mutedIcon,
    lightIcon: imagePath.neutral.huddle.mutedIcon,
  },
  [imageNames.CODE]: {
    darkIcon: imagePath.dark.action.code,
    lightIcon: imagePath.light.action.code,
  },
  [imageNames.COMMITS]: {
    darkIcon: imagePath.dark.action.commits,
    lightIcon: imagePath.light.action.commits,
  },
  [imageNames.PULL_REQUESTS]: {
    darkIcon: imagePath.dark.action.pullRequests,
    lightIcon: imagePath.light.action.pullRequests,
  },
  [imageNames.FORK_REPO]: {
    darkIcon: imagePath.dark.action.forkRepo,
    lightIcon: imagePath.light.action.forkRepo,
  },
  [imageNames.BRANCH_REPO]: {
    darkIcon: imagePath.dark.action.branchRepo,
    lightIcon: imagePath.light.action.branchRepo,
  },
  [imageNames.GIT_ACTIONS]: {
    darkIcon: imagePath.dark.action.gitActions,
    lightIcon: imagePath.light.action.gitActions,
  },
  [imageNames.GITHUB_ICON]: {
    darkIcon: imagePath.dark.action.githubIcon,
    lightIcon: imagePath.light.action.githubIcon,
  },
  [imageNames.GITHUB_ICON_WHITE]: {
    darkIcon: imagePath.dark.action.githubIcon,
    lightIcon: imagePath.dark.action.githubIcon,
  },
  [imageNames.GITHUB_ICON_INVERTED]: {
    darkIcon: imagePath.light.action.githubIcon,
    lightIcon: imagePath.dark.action.githubIcon,
  },
  [imageNames.MERGE_PR]: {
    darkIcon: imagePath.dark.action.mergePR,
    lightIcon: imagePath.light.action.mergePR,
  },
  [imageNames.CLOSE_PR]: {
    darkIcon: imagePath.dark.action.closePR,
    lightIcon: imagePath.light.action.closePR,
  },
  [imageNames.DRAFT]: {
    darkIcon: imagePath.dark.action.draft,
    lightIcon: imagePath.light.action.draft,
  },
  [imageNames.RELOAD]: {
    darkIcon: imagePath.dark.action.reload,
    lightIcon: imagePath.light.action.reload,
  },
  [imageNames.REVERT]: {
    darkIcon: imagePath.dark.action.revert,
    lightIcon: imagePath.light.action.revert,
  },
};

export function getThemeAwareIconPath(iconName, store) {
  const iconConfig = themeIconMap[iconName];
  if (!iconConfig) {
    return "";
  }

  return store.getters["theme/getIconForTheme"](iconConfig);
}
